<template>
	<div class="hello" @click="close">
		<div class="row shop">
			<!-- 设置一个动态的高度溢出时自动显示滚动条 -->
			<div class="col-lg-12  col-md-12 table-responsive" :style="{'overflow-x': 'auto','overflow-y':'hidden',height:offset_height+'px'}"  >
				<div>
					<table>
						<div>
							<table class="t-table text-nowrap ">
								<!-- 表格头部 -->
								<!-- 将表头固定 translateY的优先层级最高当高度超出时出现滚动条滚动时表头一直计算滚动的高度所以内容数据一直往上滚动而表头固定-->
								<thead class="thead">
									<tr >
										<th v-show="fields"><div class="fixed">#</div></th>
										<th v-show="fields"><div class="fixed"><input type="checkbox" v-model="btn_check" @change="tr_flag && btn_check_cli()"></div></th>
										<th class="thb" v-for="(head,index) in columns.FIELDS" :key="index"  v-show="!th_value[index]" :title="head.Comment">
											<div style="width:150px;text-overflow: ellipsis;overflow: hidden;" :style="{width:th_width[index]+'px'}" >
												{{head.Comment}} 
												<span v-show="head.isSort" @click="sort_flag && data_sort(head.Name)" style="display: inline-block;vertical-align: -3px;">
													<i class="fa-up" :class="[isup]"></i>
													<i class="fa-down" :class="[isdown]"></i>
												</span>
											</div>
										</th>
										<th v-show="(count-child_index_page+num+1)>child_index_total" style="width:16px"></th>
									</tr>
								</thead>
							</table>
						</div>
						<!-- 表格数据 -->
						<div :style="{height:(offset_height-78)+'px','overflow-y': 'auto','overflow-x':'hidden'}">
							<table class="t-table text-nowrap ">
								<tbody id="tbody" >
									<!-- 新建的列表数据   当有多个循环的时候key值不能重复-->
									<tr v-for="(num,index1) in num" :key="index1" :class="{list_color:true}" style="margin-top: 0;  align-self:flex-end">
										<td ><div class="fixed">{{index1+child_index_page}}</div></td>
										<td ><div class="fixed"><input type="checkbox" v-model="add_checkeds" :value="index1" ></div></td>
										<td class="fixed-list" v-for="(le,index) in len" :key="index">	
											<!-- 输入框根据索引显示内容当添加新项目时会把之前的索引添加到现有的索引中所以会把输入框的内容添加到新的项目中 :id="'fld'+index"-->
											<div class="input-width" :style="{width:th_width[index]+'px'}">
												<input  v-if="le.check_show" type="checkbox" v-model="check[index1+'-'+columns.FIELDS[index].Name]">
												<input style="width:100%" :readonly="readonly[index]" :placeholder="readonly[index]?'请选择':''" v-if="le.input_show" type="text" v-model="msg[index1+'-'+columns.FIELDS[index].Name]">
												<input style="width:100%" :readonly="readonly[index]" :placeholder="readonly[index]?'请选择':''" v-if="le.textarea_show" type="text" v-model="msg[index1+'-'+columns.FIELDS[index].Name]">
												<input style="width:100%" :readonly="readonly[index]" :placeholder="readonly[index]?'请选择':''" v-if="le.password_show" type="text" v-model="msg[index1+'-'+columns.FIELDS[index].Name]">
												<input style="width:100%" :readonly="readonly[index]" :placeholder="readonly[index]?'请选择':''" v-if="le.date_time_show" type="text" v-model="msg[index1+'-'+columns.FIELDS[index].Name]">
												<!-- 滑动开关 -->
												<!-- <div > -->
													<div class="onoffswitch" v-if="le.on_off_show">
														<input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" 
														:id="'myonoffswitch'+index1+'-'+index" v-model="msg_onoff[index1+'-'+columns.FIELDS[index].Name]" >
     													<label class="onoffswitch-label" :for="'myonoffswitch'+index1+'-'+index">
     													    <span class="onoffswitch-inner" style="transition:all 0.3s ease-in 0s"></span>
     													    <span class="onoffswitch-switch" style="transition:all 0.3s ease-in 0s"></span>
     													</label>
													</div>
												<!-- </div> -->
												
												<span style="width:20%" v-if="le.span_show" @click="serch(index1,index,columns.FIELDS[index],$event)" class="serch_box">
													<i class="fa fa-ellipsis-h fa-1x"></i>
												</span>
											</div>
										</td>
									</tr>										
									<!-- 初始请求的列表数据 -->
									<!-- 编辑时把数据填充到输入框中 加上item是为了避免key值的和上一个tr的key值重复-->
									<tr v-for="(item,index) in rows" :class="{list_color:dynamic[index]==index+1}" :key="index+item" @click="tr_flag && tr_list(index)">
										<!-- {{item}} -->
										<td ><div class="fixed">{{index+1+child_index}}</div></td>
										<!-- 给每个复选框绑定不一样的v-model -->
										<td ><div class="fixed"><input type="checkbox" :disabled="V_disabled" v-model="btn_checkeds" :value="index"></div></td>
										<!-- 渲染多个tr project为对象的每一项-->										
										<td class="fixed-list " v-for="(key,index_list) in columns.FIELDS" :key="index_list" :title="item[key.Name]" v-show="!td_value[index_list+'-'+index]">
											<div style="text-overflow: ellipsis;overflow: hidden;" :style="{width:th_width[index_list]+'px'}">
											<!-- 如果没有点击编辑则直接是渲染的数据 -->
												<template v-if="!edit_list[index]">
													<template v-if="fields[index_list]&&(fields[index_list].type!='onOff'&&fields[index_list].Comment!='操作')&&fields[index_list].type!='aButton'
                                                    &&fields[index_list].type!='cButton'">
														{{item[key.Name]}}
													</template>
													
													<!-- 滑动开关 -->     
														<div class="onoffswitch" v-if="fields[index_list]&&fields[index_list].type=='onOff'">
															<input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" 
															:id="'myonoffswitch'+index+key.Name"  v-model="rows_on_off[index+$route.path+item.fld_record_id+key.Name]" @click="on_off(key,item,index)">
															<!-- :checked="Boolean(project)" -->
     														<label class="onoffswitch-label" :for="'myonoffswitch'+index+key.Name">
     														    <span class="onoffswitch-inner" :style="{transition:transition_on_off}"></span>
     														    <span class="onoffswitch-switch" :style="{transition:transition_on_off}"></span>
     														</label>
														</div>
														<div v-if="fields[index_list]&&fields[index_list].type=='aButton'">
															<button @click.stop="see(index)" style="outline:none">查看子条目&gt;&gt;</button>
														</div>
														<div v-if="fields[index_list]&&fields[index_list].type=='showImg'&&item.fld_imgs">
															<button @click.stop="see_pic(index)" style="outline:none">查看图片&gt;&gt;</button>
														</div>
														<!-- 审核状态 -->
                                                        <div v-if="fields[index_list]&&fields[index_list].type=='cButton'">
															<button @click.stop="audit_status(item.fld_record_id)" style="outline:none" :disabled="confirm_sending[item.fld_record_id]" :class="{ active: isActive[item.fld_record_id] }">
																<!-- {{item['fld_istester']?test_mail:status_show[item['fld_check_status']]}} -->
																{{status_show[item['fld_check_status']]}}
															</button>
														</div>
												</template>
												<!-- 如果点击了编辑就渲染编辑后的数据 -->
												<template v-if="edit_list[index]">
													<div class="input-width">
														<!-- 编辑时自动读取每条数据的内容并填充到输入框中 (fields[index_list].type=='text'&&fields[index_list].Name!='fld_language')&&-->
														<input style="width:100%" :readonly="readonly[index_list]" :placeholder="readonly[index_list]?'请选择':''" v-if="(fields[index_list].type=='textarea')" type="text" v-model="item[key.Name]">
														<input style="width:100%" :readonly="readonly[index_list]" :placeholder="readonly[index_list]?'请选择':''" v-if="(
																																											(fields[index_list].type=='text'&&fields[index_list].Readyonly!=true)&&
																																											(fields[index_list].type=='text'&&fields[index_list].Name!='fld_title_id')&&
																																											
																																											(fields[index_list].type=='text'&&fields[index_list].Name!='fld_record_id')
																																										)" type="text" v-model="item[key.Name]">
														<input style="width:100%" :readonly="readonly[index_list]" :placeholder="readonly[index_list]?'请选择':''" v-if="(fields[index_list].type=='password')" type="text" v-model="item[key.Name]">
														<input style="width:100%" :readonly="readonly[index_list]" :placeholder="readonly[index_list]?'请选择':''" v-if="(fields[index_list].type=='date_time')" type="text" v-model="item[key.Name]">
														<!-- 滑动开关 -->

														<div class="onoffswitch" v-if="(fields[index_list].type=='onOff')">
															<input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox"
															 v-model="rows_on_off[index+$route.path+item.fld_record_id]" :id="'myonoffswitch'+index+key.Name" @click="on_off(key,item,index)">
     														<label class="onoffswitch-label" :for="'myonoffswitch'+index+key.Name">
     														    <span class="onoffswitch-inner" :style="{transition:transition_on_off}"></span>
     														    <span class="onoffswitch-switch" :style="{transition:transition_on_off}"></span>
     														</label>
														</div>	
																											 
														<!-- 如果表头的数据字段中的的name与clumns中的主键字段相同就不能更改 -->
														<!-- <span v-if="(fields[index_list].type=='text'&&fields[index_list].Name==response.PRIMARY)">{{item[key.Name]}}</span> -->
														<span v-if="(fields[index_list].type=='text'&&fields[index_list].Readyonly==true)">{{item[key.Name]}}</span>
														<!-- 是否显示其他页面的按钮 -->
														<span style="width:20%" v-if="fields[index_list].Action!=undefined" class="serch_box" @click.stop="serch(index,index_list,key,$event)">
															<i class="fa fa-ellipsis-h fa-1x "></i>
														</span>
													</div>														
												</template>
											</div>
										</td>																						
									</tr>																			
								</tbody>
							</table>
						</div>
					</table>
				</div>
			</div>
		</div>
		<!-- 如果没有数据显示 -->
		<div style="margin-top: 100px;margin-left: 50%;color: #666;" v-show="!fields">{{language_is_data}}</div>
		<!-- 底部结构 -->
		<div class="row row-a" >
			<div class="col-lg-6  col-md-2  footer footer-1" v-show="fields">
				<button @click="query" style="outline: none;"><span class="iconfont icon-chaxun"></span>{{language_query}}</button>
				<button @click="refresh" style="outline: none;"><span class="iconfont icon-shuaxin"></span>{{language_refresh}}</button>
				<button @click="updata" v-if="option.updata" :disabled="isedit" :class="{color:btn_edit}" style="outline: none;"><span class="iconfont icon-bianji"></span>{{language_updata}}</button>
				<button @click="add" v-if="option.new_add" :disabled="newly_build" :class="{color:btn_build}" style="outline: none;"><span class="iconfont icon-xinzeng4"></span>{{language_add}}</button>
				<button @click="data_export"  v-if="columns.URL_TOEXCEL" :disabled="isdel" :class="{color:btn_del}" style="outline: none;"><span class="iconfont icon-daochu"></span>{{language_export}}</button>
				<button @click="import_file"  v-if="columns.URL_IMPORTEXCEL" :disabled="isdel" :class="{color:btn_del}" style="outline: none;"><span  class="iconfont icon-import"></span>{{language_import}}</button>
				<button @click="submit(fields)" v-if="option.updata_add" :disabled="preservation" :class="{color:btn_preservation}" style="outline: none;"><span class="iconfont icon-baocun"></span>{{language_submit}}</button>
				<button @click="bt_revoke" v-if="option.revoke" :disabled="revoke" :class="{color:btn_revoke}" style="outline: none;"><span class="iconfont icon-chexiao"></span>{{language_revoke}}</button>
				<button @click="del" v-if="option.del" :disabled="isdel" :class="{color:btn_del}" style="outline: none;background: rgb(210, 98, 103);"><span class="iconfont icon-shanchu1"></span>{{language_del}}</button>
				<button @click="control_data_show_hide" style="outline: none;background: rgb(210, 98, 103);"><span class="iconfont icon-xianshiyincang"></span>{{language_show_hide}}</button>
			</div>
			<div class="popup" v-if="show_hide">
				<p class="content">{{language_confirm_deletion}}</p>
				<button class="confirm" @click="confirm_click" style="outline: none;">{{language_confirm}}</button>
				<button class="cancel" @click="cancel_click" style="outline: none;">{{language_cancel}}</button>
			</div>
			<div class="col-lg-3 col-lg-offset-1  col-md-4 total-page footer">
				<nav>
					<ul class="">
						<li>
							<a href="javascript:void(0);" @click.prevent="home_page">
								<i class="fa fa-fast-backward"></i>
							</a>
							<a href="javascript:void(0);" @click.prevent="previous_page">
								<i class="fa fa-backward"></i>
							</a>
						</li>
						<li>|<a class="page" href="javascript:void(0);" @click.stop="select_input" @keyup.enter="submit_input">{{language_the_page}}
								<input type="text" v-if="input_page" v-model="project_data.page" style="width:30px; height:20px">{{language_page_of}}
							</a>
							 <a class="page page-s" href="#">{{language_page_count}}</a>|
						</li>
						<li>
							<a href="javascript:void(0);" @click.prevent="next_page"><i class="fa fa-forward"></i></a>
							<a href="javascript:void(0);" @click="last_page"><i class="fa fa-fast-forward"></i></a>
						</li>
					</ul>
				</nav>
			</div>
			<div v-if="no_data" class="col-lg-3  col-md-2  total footer">
				<span class="page-num">{{count}}</span>
				<span class="total-num">{{language_page_number}}</span>
			</div>
			<div v-if="!no_data" class="col-lg-4  col-md-2  total">{{language_is_data}}</div>
			<!-- 控制数据的显示或隐藏 -->
			<div class="show_heid" style="width:500px" v-show="data_show_hide">
				<label class="show_heid_btn" v-for="(data,index) in fields" :key="index" >{{data.Comment}}<input v-model="btn_check_cancel[index]" checked="true" type="checkbox" @change="btn_change"></label>
			</div>
			<!-- 搜索的弹出框 -->
			<div v-if="query_show" class="modal fade query" tabindex="-1" role="dialog" style="overflow: visible;opacity: 1" v-drag>
  				<div class="modal-dialog" role="document">
  				  	<div class="modal-content">
						<div class="modal-header">
							<span class="modal-title" >{{language_search}}&hellip;</span>
							<span @click="close_win" v-if="query_show" aria-hidden="true" class="modal-span">&times;</span>
						</div>
						
						<div class="modal-body">
							<select class="body-sty" v-model="project_box" >
								<option disabled value="">{{language_Please_select}}</option>
								<option v-for="(item,index) in language_project_condition" :key="index" selected="true" :value="index">{{item}}</option>
							</select>
							<i class="increase" @click="accumulation">+</i>
						</div>
						<!-- 当点击添加的时候要遍历这个元素 -->
						<div class="input-content">
						<div class="modal-body" v-for="(item,index) in add_num" :key="index" >
							<div>
								<select name="" class="body-sle" v-model="project_slected[item]">
									<option disabled value="">{{language_Please_select}}</option>
									<option v-for="(item,index) in head_data" :key="index" :value="item">{{item}}</option>
								</select>
								<select name="" class="body-sle-one" v-model="type_slected[item]">
									<option disabled value="">{{language_Please_select}}</option>
									<option v-for="(item,index) in language_query_scope" :key="index" :value="item" >{{item}}</option>
								</select>
								<input type="text" class="body-input" :style="{verticalAlign:vertical}" :placeholder="language_input_value" v-model="condition[item]">
								<i class="body-i" @click="Query_remove(item)" :key="index">-</i>
							</div>							
						</div>
						</div>
						<div class="modal-footer">	
							<span type="button" class="btn btn-default footer-reset" data-dismiss="modal" @click="box_reset"><i class="fa fa-reply" aria-hidden="true"></i>{{language_reset}}</span>
							<span type="button" class="btn footer-query" @click="lookup">{{language_lookup}}
							<i class="fa fa-search" aria-hidden="true" ></i></span>
						</div>
  				  	</div>
  				</div>
			</div>
		</div>
		  <!-- 遮罩层 -->
  		<div @click="unmask" style="width: 100%;height: 100%;background: #e2e2e2;color: #e2e2e2;position: fixed;top: 0;opacity: .5;" v-if="mask"></div>
		<!-- <keep-alive> -->
		<template>
			<!-- <keep-alive> -->
			<tinymce-editor v-if="announcement" :language_params="language_params" :editorData="editorData" :rule_data="rule_data" @input_data="input_data" @close_project="close_project"></tinymce-editor>
			<!-- </keep-alive> -->
			<select-time v-if="box_data.time" :rule_data="rule_data" :clientY="clientY" :clientX="clientX" @close_project="close_project" @time_data="time_data"></select-time>
			<tips v-if="box_data.tips" :current_state="current_state"></tips>	
			
			<component :is="is_components" :language_pack="language_pack" :rule_data="rule_data" :ppr_action="ppr_action" :ppr_action_param="ppr_action_param" :box_fun="box_fun" 
				@close_project="close_project" @input_data="input_data"  @channel_input_data="channel_input_data" @pas_confirm="pas_confirm"
				:clientY="clientY" :clientX="clientX" @time_data="time_data" @edit_confirm="edit_confirm" @auth_data="auth_data"
				:selecte_data="selecte_data" @audit_failed="audit_failed" @approved="approved" @data_backup="data_backup" @sbmit_data="sbmit_data" @close_edit="close_edit" @import_refresh="import_refresh"
				@close_select="close_select" :area_data="area_data" @selecte_btn="selecte_btn" @get_role_data="get_role_data" :area_service_id="area_service_id" :columns="columns" :file_close="box_data.upload_file" :key_s="key_s">
				{{head_title}}
			</component>
			
		</template>
		<!-- </keep-alive> -->
	</div>	
</template>
<script>
	import choiceApp from "../box/choice_app";
	import ConfirmSendingEmail from '../box/confirm_sending_email.vue'
	import AuditStatus from '../box/audit_status.vue';
	import selectDistributionPackage from "../box/Project_engineering";
	import userPas from "../box/user_pas";
	import selectTime from "../box/p_time";
	import edit from "../box/edit";
	import selectService from "../box/select_service";
	import mailConditions from "../box/mail_conditions";
	import editItems from "../box/edit_items";
	// import selectItems from "../box/select_items";
	import ruleJson from "../box/slecete_rule_json";
	import jurisdiction from "../box/jurisdiction";
	import authRoleEdit from "../box/auth_role_edit";
	import tips from "../box/tips";
	import uploadFile from "../box/upload_file";
	import { mapState } from 'vuex';
	import {mapMutations} from 'vuex';
	import api from "../api/index.js";
	import tinymceEditor from './tinymce-editor';
	import vChannelsAreas from '../box/v_channels_areas.vue';
	import GameVersion from '../box/game_version.vue';

	import SelectRegion from '../box/select_region.vue';
	import SelectCountry from '../box/select_country.vue';

	import AnnouncementType from "../box/announcement_type.vue";
	import AreaService from '../box/area_service.vue';
	import TestEquipment from '../box/test_equipment.vue'
	import IsTest from '../box/is_test.vue'
	//语言包模块
	import language_pack from "../store/language_pack.js"
	import viewPicture from "../box/view_picture.vue"
	export default {
		name: 'operationTable',
		data() {
			return {
				test_mail:'发送测试',
				//根据状态字段显示的文字
                status_show:{0:'待审核',1:'审核通过',2:'审核不通过'},
				//审核后的样式
                isActive:{},
                //审核后禁止点击
                confirm_sending:{},
				//审核通过的索引
                approved_index:null,
				area_backup:null,
				//危机逃脱的备份数据
				area_data:null,
				//危机逃脱的区服id
				area_service_id:null,
				//开关的动画
				transition_on_off:'',
				//输入框是否只读
				readonly:{},
				//传递各组件用于通过字段判断请求哪个接口
				key_s:null,
				//富文本框的显示隐藏
				announcement:false,
				//富文本组件的数据
				editorData: '',
				msg_onoff:{},
				rows_on_off:{},
				vertical:'',
				language_pack:language_pack,
				//是否显示遮罩层
				mask:false,
				//选择的数据
				selecte_data:null,
				//活动参数（点击三个点）
				ppr_action_param:null,
				//切换组件
				is_components:'',
				//总页数
				language_page_count:'共'+parseInt(this.project_data.total)+'页',
				//第几页
				language_page_of:this.project_data.page+'页',
				//不同组件的标题
				head_title:'',
				//计算点击元素距离左上边框的距离
				clientX:null,
				clientY:null,
				//是否禁止点击正反序的三角
				sort_flag:true,
				//当前的状态
				current_state:'',
				//表头滚动的状态
				tans_late:'',
				//数据的的副本
				project_data_copy:this.project_data.records,
				//当点击添加的时候累加
				increasing:0,
				//第多少条数据
				child_index_page:1,
				//数据列表颜色控制
				dynamic:{},
				//编辑新建时输入框中的值
				rule_data:null,
				//查询的显示框
				query_show:false,
				//是否输入页数
				input_page: false,
				//用户信息
				userInfo: null,
				//默认的序号
				child_index: 0,
				//每一页包含的项目数目
				child_index_total: 16,
				//默认新建时遍历的多少条数据
				num: 0,
				//新建时根据每一项数据渲染不同的输入框或选择框
				len: [],
				//输入框数据
				msg: {},
				//是否显示输入框
				edit: false,
				//是否显示复选框
				chected: false,
				//动态复选框
				check: [],
				//判断底部按钮的数据
				option: {
					//删除
					del: true,
					//保存 移除
					new_add: true,
					//编辑
					updata: true,
					//保存
					updata_add: true,
					//撤销
					revoke:true
				},
				//排序的正反三角
				sort: false,
				//正序
				isup: 'itup',
				//倒序
				isdown: 'itdown',
				//保存的禁止点击
				preservation: true,
				//撤销的禁止点击
				revoke: true,
				//编辑的禁止点击
				isedit: false,
				//删除的禁止点击
				isdel: false,
				//新建的禁止点击
				newly_build: false,
				//是否禁用的选项
				btn_preservation: true,
				btn_revoke: true,
				btn_edit: false,
				btn_del: false,
				btn_build: false,
				//总按钮是否选中
				btn_check: '',
				//列表按钮
				btn_checkeds: [],
				//添加复选框
				add_checkeds:[],
				//索引号
				list_index: null,
				//多个索引号
				list_indexes: [],
				//删除弹框
				show_hide: false,
				//确认取消是否执行
				confirm_data: null,
				//列表是否有选中的按钮
				list_some: '',
				//编辑列表的数据
				edit_list: [],
				//编辑更新的数据对象
				updata_edit: [],
				//当总项目条数大于16时显示一页16条数据
				data_page: 16,
				//查询时的查询条件的数组
				head_data:[],
				//查询时的判断条件
				// query_scope:['等于','不包含','不等于','大于','大于等于','小于','小于等于','包含','开头是','开头不是','结尾是','结尾不是','为空','不为空'],
				//查询代号
				query_code:['eq','nc','ne','gt','ge','lt','le','cn','bw','bn','ew','en','nu','nn'],
				//查询多条数据累加选项
				add_num:[],
				//查询的添加和移除
				condition:[],
				//搜索输入框的添加
				search_data:0,
				//查询项目选择框
				project_slected:[],
				//查询类型选择框
				type_slected:[],
				//项目条件
				// project_condition:['满足所有条件','满足任一条件'],
				//项目选择框
				project_box:'',
				//页数
				page:1,
				//组件弹框数据
				box_data:{
					time:false,
					tips:false,
				},
				//传递的头部数据
				ppr_action:null,
				//数据索引当弹框数据确认数据时输入框的值变化
				box_index:{
					index1:null,
					index:null,
					box_key:null,	
				},
				//每条数据是否点击的标志
				tr_flag:true,
				//时间选择标志
				//弹框的函数数据
				box_fun:null,
				//弹框数据
				box_res:[],
				//权限数组中的数据
				sort:'desc',
				//获取数据框的高度
				offset_height:null,
				//查询的条件
				Query_project:null,
				//查询接口是否调用、
				lookup_flag:false,
				//缓存的排序结果
				sort_name:this.columns.PRIMARY,
				//头部内容
				fields:null,
				//新建保存完数据的标志
				new_data:false,
				//数据的显示隐藏
				data_show_hide:false,
				//获取选中项的值true或者false
				btn_check_cancel:[],
				//定义数据对象保存每个td的boolean值
				td_value:{},
				//定义头部数据对象保存每个th的boolea值
				th_value:{},
				th_width:[],
				//是否禁止选中复选框
				V_disabled:false,
				//缓存id
				fld_record_id:null,
				//新建时生效和失效时间
				effective:null,
				expiration:null,
				//当新建或编辑提交时
				new_expiration_effective:true,
				edit_expiration_effective:true,
				language_params:0,//语言参数
			}
		},		
		created(){
			// console.log(this.rows)
			//判断是不是谷歌浏览器
			this.is_chrome()
			//根据屏幕的高度计算数据的显示条数
			this.count_page();
			//请求所有弹框的数据根据字段显示是否有查询的三个点
			this.serch_fn();
			//刷新时记住状态
			this.refresh_status();
			//刷新保持正反序状态
			this.refresh_kee_order();
			//加载页面时读取开关的属性，并且根据值判断是否开启开关
			this.sub_on_off()
			//当路由是/Sandbox/Setnotice/tbl_notice或者/Sandbox/Setnotice/tbl_horse_lamp时自动查询数据
			// this.auto_query_data(this.$route.path)	
		},		
		mounted() {
			// this.$router.beforeEach((to,from,next)=>{
			// 	console.log(to,from)
			// 	next()
			// });
			// this.$router.beforeResolve((to,from,next)=>{
			// 	console.log(to,from)
			// 	next()
			// })
			// this.$router.afterEach((to,from,next)=>{
			// 	console.log(to,from)
			// })
		},
		components:{
			ConfirmSendingEmail,
			AuditStatus,
			//富文本编辑器
			tinymceEditor,
			//项目工程组件 (Admin本地数据库[项目工程] 菜单编辑[类型] 其他页面[项目工程] 编辑Action[项目工程] 操作表字段[编辑控件 编辑操作] 数据类型[项目工程] 数据类型值[项目工程 类型id]) (Tank 活动商店[重置周期] 活动数据[活动类型 活动状态] 活动奖励[重置周期] 活动任务[重置周期] 客户端可见服务器管理[客户端名] 客户端资源升级[客户端名] 客户端代码升级[客户端名] 兑换码生成[礼包id 生成状态] 邮件模板[删除类型] 系统邮件[邮件模板id] 房间服务器[服务器所属分组] 测试设备[类型]渠道商品定义[渠道的名字 官方id 货币类型] 商品定义[商品类型])(巅峰战舰 礼包码[批次] 礼包生成[生成状态] 礼包管理[邮件标题 邮件内容] 资源升级[资源类型] 测试设备[设备类型])
			choiceApp,
			// 坦克活动数据中的对应渠道组件  (Tank 活动数据[对应渠道 生效分区] 游戏内公告[生效分区] 客户端可见服务器管理[可以看见的服务器分组 测试设备可见的服务器分组]系统邮件[生效分区])
			selectDistributionPackage,
			//管理员密码组件 (Admin 用户[管理员密码])
			userPas,
			//时间的组件 (Tank 活动数据[活动开始时间 活动结束时间 活动展示开始时间 活动展示结束时间] 首页公告[组后修改时间] 游戏内公告[最后修改时间 公告展示开始时间 公告展示结束时间]系统公告[公告发送时间] 兑换码生成[生效时间 过期时间] 封停账号[解锁时间] 系统邮件[到期时间])
			selectTime,
			//编辑框的组件 (Admin编辑Action[模板参数] Tank首页公告[测试公告 正式公告] 巅峰挑战任务[任务描述] 礼包[邮件内容] 邮件模板[邮件标题 邮件内容])巅峰战舰(礼包管理[邮件标题 邮件内容] 跑马灯[内容] 物品[describe] 首页公告[测试公告 正式公告] 服务器内公告[公告内容 落款 导航 背景图 内容 条件]资源升级[下载地址 下载地址测试])
			edit,
			//封停角色 用户ID (Tank封停角色[用户id] 封停账号[用户id])
			selectService,
			//系统邮件 条件组件 (Tank系统邮件[条件])
			mailConditions,
			//邮件物品 编辑物品  (Tank礼包[物品数据] 邮件模板[邮件物品])
			editItems,
			//选择物品的组件 (Tank巅峰挑战任务[奖励物品])
			// selectItems,
			//权限组件 (Admin 用户[权限])
			jurisdiction,
			//权限数组 (Admin 角色[权限数组])
			authRoleEdit,
			//提示组件
			tips,
			// 选择文件组件
			uploadFile,
			//危机逃脱  版本 渠道
			vChannelsAreas,
			//危机逃脱 反馈信息 图片展示
			viewPicture,
			//危机逃脱 邮件列表 角色json
			ruleJson,
			//危机逃脱 区服（邮件列表 登录公告 跑马灯）
			GameVersion,
			//危机逃脱 游戏内公告 （公告的类型）
			AnnouncementType,
			//危机逃脱 游戏区服
			AreaService,
			//危机逃脱 设备信息
			TestEquipment,
			//危机逃脱 是否为测试项
			IsTest,
			//危机逃脱 选择地区
			SelectRegion,
			//危机逃脱 选择国家
			SelectCountry,
		},
		props: {			
			//内容数据
			rows: Array,
			//头部数据
			columns: Object,
			//动态内容页数
			project_data: Object,
			//项目索引
			sub_index: Number,
			//项目路由
			sub_url: String,
			//请求的数据接口地址
			response: Object,
			//父组件数据请求完成的标志
			istrue: Object,
			//查询接口请求完成标志
			isquery:Boolean,
			//查询的数据是否为空
			no_data:Boolean,
			// flag_c:Array,		
		},
		computed: {	
			//切换语言
			...mapState({
				language_sel_language:'sel_language',
				// cache_action_data:'cache_action_data',
				language_query_scope(){return this.$attrs.language_pack[this.language_sel_language].query_scope},
				language_project_condition(){return this.$attrs.language_pack[this.language_sel_language].project_condition},
				language_Please_select(){return this.$attrs.language_pack[this.language_sel_language].Please_select},
				language_lookup(){return this.$attrs.language_pack[this.language_sel_language].lookup},
				language_reset(){return this.$attrs.language_pack[this.language_sel_language].reset},
				language_search(){return this.$attrs.language_pack[this.language_sel_language].search},
				language_is_data(){return this.$attrs.language_pack[this.language_sel_language].no_data},
				language_cancel(){return this.$attrs.language_pack[this.language_sel_language].cancel},
				language_confirm(){return this.$attrs.language_pack[this.language_sel_language].confirm},
				language_confirm_deletion(){return this.$attrs.language_pack[this.language_sel_language].confirm_deletion},
				language_input_value(){return this.$attrs.language_pack[this.language_sel_language].input_value},
				language_the_page(){
					if(this.language_sel_language=='cn'){
						this.language_page_of=this.project_data.page+'页';
						this.language_page_count='共'+parseInt(this.project_data.total)+'页'
					}
					if(this.language_sel_language=='en'){
						this.language_page_of=this.project_data.page;
						this.language_page_count='of '+parseInt(this.project_data.total)
					}
					if(this.language_sel_language=='jp'){
						this.language_page_of=this.project_data.page;
						this.language_page_count='共に'+parseInt(this.project_data.total)+'ページ'
					}
					return this.$attrs.language_pack[this.language_sel_language].page
				},
				language_query(){return this.$attrs.language_pack[this.language_sel_language].query},
				language_refresh(){return this.$attrs.language_pack[this.language_sel_language].refresh},
				language_updata(){return this.$attrs.language_pack[this.language_sel_language].edit},
				language_add(){return this.$attrs.language_pack[this.language_sel_language].newly_build},
				language_export(){return this.$attrs.language_pack[this.language_sel_language].export},
				language_import(){return this.$attrs.language_pack[this.language_sel_language].import},
				language_submit(){return this.$attrs.language_pack[this.language_sel_language].preservation},
				language_revoke(){return this.$attrs.language_pack[this.language_sel_language].revoke},
				language_del(){return this.$attrs.language_pack[this.language_sel_language].del},
				language_show_hide(){return this.$attrs.language_pack[this.language_sel_language].Show_hide},
			}),		
			//计算当总数据不足16条时有多少条显示到多少条
			count() {
				//当前页的数据条数是否比每页设定的条数小
				if(this.rows){
					if (this.rows.length < this.data_page) {
						if(this.language_sel_language=='cn'){
							return '第'+this.child_index_page+'到第'+(this.rows.length+(this.page*this.data_page-this.data_page)+this.increasing)+'条';//页数*16-16
						}
						if(this.language_sel_language=='en'){
							return 'page '+this.child_index_page+' page of '+(this.rows.length+(this.page*this.data_page-this.data_page)+this.increasing)+' article';
						}
						if(this.language_sel_language=='jp'){
							return 'ページ'+this.child_index_page+'共に'+(this.rows.length+(this.page*this.data_page-this.data_page)+this.increasing)+'ページ';
						}					
					} else {
						if(this.language_sel_language=='cn'){
							//如果是动态的页数那么返回本页最后一条页数值
							return '第'+this.child_index_page+'到第'+this.child_index_total+'条';
						}
						if(this.language_sel_language=='en'){
							return 'page '+this.child_index_page+' of '+this.child_index_total+' article';
						}
						if(this.language_sel_language=='jp'){
							return 'ページ'+this.child_index_page+'共に'+this.child_index_total+'ページ';
						}
					}
				}				
			},
			//切换语言
			language_page_number(){
				if(this.rows){
					if(this.language_sel_language=='cn'){
						return '共'+(this.increasing+this.project_data.records)+'条'
					}
					if(this.language_sel_language=='en'){
						return (this.increasing+this.project_data.records)+' item in total'
					}
					if(this.language_sel_language=='jp'){
						return '合計'+(this.increasing+this.project_data.records)+'項目'
					}
					
				}
				
			},
			//计算是否显示输入页数的输入框
			input_box: function() {
				//如果输入了页数执行
				if (this.input_page == false) {
					return this.project_data.page
				}
			},	
		},
		watch:{
			columns:{
				handler(newValue,oldValue){
					// alert(7)
					//columns变化时赋值变量初始值
					this.change_columns(newValue);					
					//数据为空时的显示
					this.count_data();
					//判断底部操作按钮的显示隐藏
					this.operation_isshow();
					//保存状态
					this.refresh_status();
					//列加载宽度
					this.calculated_width();
					//撤销选中的列表
					this.bt_revoke_ref()
					// this.bt_revoke()
					// this.refresh()				
					//关闭查询弹框
					this.close_win();	
					this.load_confirm_send()				
											
				},
					deep: true,
    				immediate: true
			},
			rows(){
				this.sub_on_off()
				//切换路由把隐藏的数据全部显示
				this.switch_route()	;
				this.load_confirm_send()
			},
			$route(){
				this.transition_on_off='none';
			}
		},
		methods: {
			//页面加载时读取fld_status判断是否确认点击
            load_confirm_send(){
				// alert(0)
                // var data=[];
                // this.rows.forEach((item,index)=>{
                //     if(item.fld_type==0){
                //         data.push(item)
                //     }
                // })
                this.rows.forEach((item,index)=>{
					// if(item.fld_istester==0){
                    	if(item.fld_check_status==1){
                    	    this.confirm_sending[item.fld_record_id]=true;
                    	    this.isActive[item.fld_record_id]=true;
                    	}     
					// }else{
					// 	if(item.fld_check_status==1){
                    // 	    this.confirm_sending[item.fld_record_id]=false;
                    // 	    this.isActive[item.fld_record_id]=false;
                    // 	}
					// }          
                })
            },
			//审核不通过
            async audit_failed(rich_text){
				// alert(0)
                // var item;
                // this.rows.forEach((item_a,index)=>{
                //     if(item_a.fld_record_id==this.approved_index){
                //         this.rows[index].fld_check_status=2;
                //         item=this.rows[index];
                //         this.rows[index].fld_reason=rich_text;
                //     }
                // })
                // this.updata_edit.push(item);
                // this.list_some=true;
				// this.$emit('parent_data_sort',  this.sort,this.sort_name,1);
                // this.is_components='';
				var item;
				this.updata_edit=[];
                this.rows.forEach((item_a,index)=>{
                    if(item_a.fld_record_id==this.approved_index){ 
							this.rows[index].fld_check_status=2;                       
                        item=this.rows[index];
                       
                    }
                })
                this.updata_edit.push(item);
                this.list_some=true;
                this.is_components='';
                var parameter={};
                for (let k in item) {
                    if(k=='fld_modif_time'||k=='fld_create_time'||k=='fld_login_time'){
						continue
					}
					//如果是复选框转换成数字类型
					if(typeof(item[k]) == 'boolean'){
						item[k] = Number(item[k])
					};	
					this.fields.forEach((item1)=>{						
							//当没有值的时候获取最新的时间
							if(k==item1.Name&&item1.FieldType=="datetime"||item1.FieldType=='timestamp'){
                                if(item[k]==null){
                                    item[k]=''
                                }
                                if(item[k]!='N/A'&&item[k]!=''){
                                    item[k]=item[k]+' '+window.sessionStorage.getItem('time_zone');
                                }
                                	//将当前时区转换成零时区
									item[k]=this.change_time_zone(item[k]);							
							}					
					})
					parameter[k] = item[k];													
				}
				
                // parameter.oper = 'edit';
				// parameter._oper = 'edit';
				// parameter.userInfo = this.userInfo;
                // this.async_error(api.addSubmitData('/bin/Sandbox/Launcher/tbl_email_title_green/jqgrid_oper/add',parameter));
					// var parameter1={};
					parameter.fld_record_id=item.fld_record_id;
					parameter.fld_check_status=2;
					parameter.fld_reason=rich_text;
                	parameter.oper = 'edit';
					parameter._oper = 'edit';
					parameter.userInfo = this.userInfo;
					// console.log(this.columns)
					await this.async_error(api.addSubmitData(this.columns.URL_UPDATE,parameter));

				// }
                	this.$emit('parent_data_sort',  this.sort,this.sort_name,this.page);
				// if(item.fld_istester==0){
				// 	this.confirm_sending[item.fld_record_id]=true;
                // 	this.isActive[item.fld_record_id]=true;
				// }else{
				// 	this.confirm_sending[item.fld_record_id]=false;
                // 	this.isActive[item.fld_record_id]=false;
				// }
                
            },
			//审核通过
            async approved(){
                var item;
				this.updata_edit=[];
                this.rows.forEach((item_a,index)=>{
                    if(item_a.fld_record_id==this.approved_index){ 
							this.rows[index].fld_check_status=1;                       
                        item=this.rows[index];
                       
                    }
                })
                this.updata_edit.push(item);
                this.list_some=true;
                this.is_components='';
                var parameter={};
                for (let k in item) {
                    if(k=='fld_modif_time'||k=='fld_create_time'||k=='fld_login_time'){
						continue
					}
					//如果是复选框转换成数字类型
					if(typeof(item[k]) == 'boolean'){
						item[k] = Number(item[k])
					};	
					this.fields.forEach((item1)=>{						
							//当没有值的时候获取最新的时间
							if(k==item1.Name&&item1.FieldType=="datetime"||item1.FieldType=='timestamp'){
                                if(item[k]==null){
                                    item[k]=''
                                }
                                if(item[k]!='N/A'&&item[k]!=''){
                                    item[k]=item[k]+' '+window.sessionStorage.getItem('time_zone');
                                }
                                	//将当前时区转换成零时区
									item[k]=this.change_time_zone(item[k]);							
							}					
					})
					parameter[k] = item[k];													
				}
				
                // parameter.oper = 'edit';
				// parameter._oper = 'edit';
				// parameter.userInfo = this.userInfo;
                // this.async_error(api.addSubmitData('/bin/Sandbox/Launcher/tbl_email_title_green/jqgrid_oper/add',parameter));
					// var parameter1={};
					parameter.fld_record_id=item.fld_record_id;
					parameter.fld_check_status=1
                	parameter.oper = 'edit';
					parameter._oper = 'edit';
					parameter.userInfo = this.userInfo;
				   await this.async_error(api.addSubmitData(this.columns.URL_UPDATE,parameter));
				// }
                this.$emit('parent_data_sort',  this.sort,this.sort_name,this.page);
				if(item.fld_istester==0){
					this.confirm_sending[item.fld_record_id]=true;
                	this.isActive[item.fld_record_id]=true;
				}else{
					this.confirm_sending[item.fld_record_id]=false;
                	this.isActive[item.fld_record_id]=false;
				}
                
            },
			//审核状态
            audit_status(id){
                this.approved_index=id;				               
                this.rows.forEach((item,index)=>{
                    if(item.fld_record_id==id){
						// if(item.fld_istester==0){
							this.is_components='AuditStatus';
							this.rule_data=this.rows[index].fld_reason;
						// }else{
						// 	this.is_components='ConfirmSendingEmail'
						// }
                        
                    }
                })
                
            },
			//查看图片
			see_pic(index){
				this.is_components="viewPicture";
				this.rule_data=this.rows[index].fld_imgs;
			},
			//切换路由把隐藏的数据全部显示
			switch_route(){
				// console.log(this.fields)
				this.fields.forEach((ite,index)=>{
					this.btn_check_cancel[index]=true
					this.btn_change()
				})
			},
			//columns变化时赋值变量初始值
			change_columns(newValue){
				this.is_components='';
				this.fields=newValue.FIELDS
				this.response=newValue;
				this.search_data=0;
				this.sort_name=this.columns.PRIMARY	
			},
			//点击查看时根据recode id进行title id的查询
			see(index){	
				// console.log(this.response.PRIMARY)		
				this.fld_record_id=this.rows[index].fld_record_id;
				window.sessionStorage.setItem('title_id',this.fld_record_id);
				// console.log(this.fld_record_id)
				var time=new Date().getTime();
				// this.rows[index].fld_title.split(',');
				var project={groupOp:'AND'};
				project.rules=[];
				project.rules.push({});
				project.rules[0].field='fld_title_id';
				project.rules[0].op='eq';
				project.rules[0].data=this.rows[index].fld_record_id;
				window.sessionStorage.setItem('fld_record_id',this.rows[index].fld_record_id);
				project=JSON.stringify(project);
				var parameter=this.dynamic_interface_parameters(true,time,this.data_page,this.page,this.response.PRIMARY,this.sort,project);
				this.userInfo=JSON.stringify(this.userInfo);
				parameter.userInfo=this.userInfo;
				if(this.$route.path=='/Sandbox/Launcher/tbl_notice_title'){
					// alert(3)
					this.$router.push('/Sandbox/Launcher/tbl_notice');
					this.$emit('change_rows',parameter)
				}
				if(this.$route.path=='/Sandbox/Launcher/tbl_horse_title'){
					// alert(4)
					this.$router.push('/Sandbox/Launcher/tbl_horse_lamp');
					this.$emit('change_rows',parameter)					
				}
				if(this.$route.path=='/Sandbox/Launcher/tbl_innotice_title'){
					// alert(5)
					this.$router.push('/Sandbox/Launcher/tbl_innotice');
					this.$emit('change_rows',parameter)					
				}
				if(this.$route.path=='/Sandbox/Launcher/tbl_email_title'){
					// alert(6)
					this.$router.push('/Sandbox/Launcher/tbl_email');
					this.$emit('change_rows',parameter)					
				}
				if(this.$route.path=='/Sandbox/Launcher/tbl_emailSi_title'){
					// alert(7)
					this.$router.push('/Sandbox/Launcher/tbl_emailSi');
					this.$emit('change_rows',parameter)					
				}


				if(this.$route.path=='/Sandbox/Launcher/tbl_giftpackage'){
					// alert(7)
					this.$router.push('/Sandbox/Launcher/tbl_gift_content');
					this.$emit('change_rows',parameter)					
				}
				// alert('zi')
			},
			// ...mapMutations(['change_cache_action_data']),
			//判断是不是ie浏览器
			isIE(){
  				if (!!window.ActiveXObject || "ActiveXObject" in window){
					  return true ;
				  }else{
					  return false ;
				  }
  			},
			//点击开关重新加载页面
			async on_off(key,item,index){
				// console.log(key)
				this.transition_on_off='all 0.3s ease-in 0s';
				// console.log(index+this.$route.path+item.fld_record_id+key.Name)
				if(!this.isIE()){
					this.rows_on_off[index+this.$route.path+item.fld_record_id+key.Name]=!this.rows_on_off[index+this.$route.path+item.fld_record_id+key.Name];
				}
				let parameter={};
				//当有复选框的时候把boolean转换成数字类型
				if(this.fields){
						for (let k in item) {
                    if(k=='fld_modif_time'||k=='fld_create_time'||k=='fld_login_time'){
						continue
					}
					//如果是复选框转换成数字类型
					if(typeof(item[k]) == 'boolean'){
						item[k] = Number(item[k])
					};	
					this.fields.forEach((item1)=>{						
							//当没有值的时候获取最新的时间
							if(k==item1.Name&&item1.FieldType=="datetime"||item1.FieldType=='timestamp'){
                            //    var tem; 
                                if(item[k]==null){
                                    item[k]=''
                                }
                                if(item[k]!='N/A'&&item[k]!=''&&item[k].indexOf("UTC"!=-1)){
                                    item[k]=item[k]+' '+window.sessionStorage.getItem('time_zone');
                                }
                                	//将当前时区转换成零时区
									item[k]=this.change_time_zone(item[k]);							
							}
						if(k==key.Name&&item1.type=='onOff'){
							item[k]=Number(this.rows_on_off[index+this.$route.path+item.fld_record_id+key.Name])
						}					
					})
					parameter[k] = item[k];													
				}
				parameter.oper = 'edit';
				parameter._oper = 'edit';
				parameter.userInfo = this.userInfo;
				var res=await this.async_error(api.editSubmitData(this.response,parameter));
				if(!res){
        		  return false
        		};
				this.child_index=this.child_index*this.project_data.page;
				let page=this.project_data.page;
				// this.fields=fields;
				//如果返回-1执行提示框
				if(res.data.error==-1){
					this.box_data.tips=true;
					this.current_state=res.data.message;
					setTimeout(()=>{
						this.box_data.tips=false;
					},2000)
					this.bt_revoke()
				}				
				//如果调用了查询接口那么添加的时候会自动请求查询接口（所有的数据）
				if(this.Query_project){
					// alert(0)
					// this.lookup()传递page当是编辑的时候在哪页编辑就刷新哪页（当是新建时是从第一页开始，当查询的时候也是从第一页开始）
					this.$emit('query',this.Query_project,this.sort,page);
					// this.refresh();
					// this.bt_revoke()
					this.$emit('parent_data_sort', this.sort,this.sort_name,page);
				}else{
					// alert(1)
					// this.refresh();
					// this.bt_revoke()
					this.$emit('parent_data_sort',  this.sort,this.sort_name,page);
				}
				}
								
			},
			//加载页面时读取开关的属性，并且根据值判断是否开启开关
			sub_on_off(){
			// this.transition_on_off='all 0.3s ease-in 0s';
			this.rows.forEach((item,index)=>{
				
				this.fields.forEach((ite,index1)=>{
					// console.log(ite.type)
					if(ite.type=='onOff'){
						// alert(0)
						if(item[ite.Name]==1){
							// console.log('11111111')
							this.rows_on_off[index+this.$route.path+item.fld_record_id+ite.Name]=true
						}else{
							this.rows_on_off[index+this.$route.path+item.fld_record_id+ite.Name]=false
						}
						
					}
				})
			})	
			},
			//点击遮罩关闭弹框
			unmask(){
				this.mask=false;
				this.query_show=false;
				this.announcement=false;
				this.is_components=''
			},
			//刷新保持正反序状态
			refresh_kee_order(){
				let sord=window.sessionStorage.getItem('sord')
				if(sord=='asc'){
					this.isup = 'isup';
					this.isdown = 'isdown';
				}
				if(sord=='itup'){
					this.isdown = 'itdown';
					this.sort='desc';
				}
			},
			//每个列的加载宽度
			calculated_width(){
				this.th_width=[];
				this.fields.forEach((item)=>{
					if(item.ShowWidth){
						this.th_width.push(item.ShowWidth)
					}else{
						this.th_width.push(150)
					}
				})
			},
			//判断是不是谷歌浏览器
			is_chrome(){
				if(navigator.userAgent.indexOf('Chrome') > -1){
					this.vertical= 'none'
				}else{
					this.vertical= 'bottom'
				}
			},
			//刷新时记住状态
			refresh_status(){
				this.page=Number(window.sessionStorage.getItem('page'));//刷新时可以保持状态，但是切换时就不能正常显示正确的页数
				if(this.page!=1){
					
					this.child_index=Number(window.sessionStorage.getItem('child_index'));
					this.child_index_total=Number(window.sessionStorage.getItem('child_index_total'));
					this.child_index_page=Number(window.sessionStorage.getItem('child_index_page'));
				}else{
					this.$nextTick(()=>{
						this.child_index=0;
						this.child_index_page=1;
						this.child_index_total=this.data_page
					})
				}
				// this.child_index=0
			},
			//保存项目的页数
			local_storage(){
				window.sessionStorage.setItem('child_index',this.child_index);
				window.sessionStorage.setItem('child_index_total',this.child_index_total);
				window.sessionStorage.setItem('child_index_page',this.child_index_page);
			},
			//取消选中
			deselect(){
				if(this.new_flag){
					this.preservation = false;
					this.btn_preservation = false;
					this.tr_flag=true;
					this.newly_build=false;
					this.btn_build = false;
					this.isedit = true;
					this.btn_edit = true;
					//删除的禁止点击
					this.isdel = true;
				   //是否禁用删除的样式
					this.btn_del = true;
					//撤销的禁止点击
					this.revoke = false;
				 	//是否禁用撤销的样式
					this.btn_revoke = false;
				}else{
					this.newly_build=false;
					this.btn_build = false;
					//保存的禁止点击
					this.preservation = true;
					//撤销的禁止点击
					this.revoke = true;
					//编辑的禁止点击
					this.isedit = false;
					//删除的禁止点击
					this.isdel = false;
					//是否禁用保存的样式
					this.btn_preservation = true;
					//是否禁用撤销的样式
					this.btn_revoke = true;
					//是否禁用删除的样式
					this.btn_del = false;
					//是否禁用编辑的样式
					this.btn_edit = false;
				}									
				if(this.list_some == true){
					if (this.btn_checkeds.length>0) {
						this.btn_checkeds.forEach((item,i)=>{
							//不渲染编辑列表
							this.edit_list[item] = false;
						})
						//复选框为空
						this.btn_checkeds=[];
						//总复选框为空
						this.btn_check = false
						this.dynamic={};
					}									
				}
			},
			//控制数据的显示隐藏（复选框变化时执行）
			btn_change(){
				// console.log(this.rows)
				this.rows.forEach((ite,index2)=>{
					this.btn_check_cancel.forEach((item,index1)=>{
						if(item==true){
							this.td_value[index1+'-'+index2]=false;
							this.th_value[index1]=false;
						}else{
							this.td_value[index1+'-'+index2]=true;
							this.th_value[index1]=true;
						}
					})					
				})
			},
			//控制数据弹框的显示隐藏
			control_data_show_hide(){
				if(this.data_show_hide){
					this.data_show_hide=false
				}else{
					this.data_show_hide=true
				}
			},
			//导入成功刷新
			import_refresh(){
				this.refresh()
			},
			//错误提示
			error_message(message){
				this.sel_tips=true;
				this.current_state=message;
				window.setTimeout(()=>{
					this.sel_tips=false;
					
				},2000)
				this.anate=false;
			},
			//捕获异步错误
			async_error(promise){
				return promise.then(res => res).catch(error => this.error_message(error));
			},
			//导出
			async data_export(){
				// alert(0)				
				this.data_show_hide=false;
				let res = await this.async_error(api.exportData(this.columns,this.userInfo));
				if(!res){
          			return false
        		};
				// console.log(this.api+res.data.url+'?type=excel')
				window.location.href=this.api+res.data.url+'?type=excel';
				
			},
			//导入excel文件
			import_file(){
				// alert(2)
				this.data_show_hide=false;
				this.is_components='uploadFile';
				this.head_title='--'+this.$attrs.language_pack[this.language_sel_language].select_edit+'--';
			},
			//判断底部操作按钮的显示隐藏
			operation_isshow(){
				//判断是否有columns接口数据
				if (this.response != null) {
					//没有添加的时候
					if (this.response.JQ_GRID_ADD == undefined) {
						this.option.new_add = false
					}else{
						this.option.new_add = true
					}
					//没有删除的时候
					if (this.response.JQ_GRID_DEL == undefined) {
						this.option.del = false
					}else{
						this.option.del = true
					}
					//没有更新的时候
					if (this.response.JQ_GRID_UPDATE == undefined) {
						this.option.updata = false
					}else{
						this.option.updata = true
					}
					//没有保存的时候
					if (this.response.JQ_GRID_UPDATE == undefined && this.response.JQ_GRID_ADD == undefined) {
						this.option.updata_add = false
					}else{
						this.option.updata_add = true
					}
				};
			},
			//数据为空时的显示
			count_data(){
				this.userInfo = window.sessionStorage.getItem('userInfo');
				//如果页数返回undefined怎默认第一页
				if (this.project_data.page == undefined) {
					this.project_data.page = 1;
				}
				//如果数据返回为空时
				if (JSON.toString(this.rows) == "[]") {
					this.rows = [{
						name: "name"
					}];
				}
			},
			//根据屏幕的高度计算显示的页数
			count_page(){
				//计算显示框的高度
				this.offset_height=window.screen.height-280;
				//根据屏幕的高度计算显示的页数
				this.data_page=parseInt(this.offset_height/43-1);
				this.child_index_total=this.data_page;
			},
			//动态接口参数
			dynamic_interface_parameters(search,nd,rows,page,sidx,sord,filters){
				return {_search:search, nd:nd, rows:rows, page:page, sidx:sidx, sord:sord, filters:filters, searchField:'', searchString:'', searchOper:'',}
			},
			//请求所有弹框的数据根据字段显示是否有查询的三个点
			async serch_fn(){
				let time=new Date().getTime(); 
				//动态参数
				var parameter=this.dynamic_interface_parameters(false,time,50,1,'fld_record_id','desc','');
				parameter.userInfo=this.userInfo;
				let res=await this.async_error(api.actionFn(parameter));
				if(!res){
        		  return false
        		};
				//获取接口数据过滤出时间的字段
				if(res.data){
					res.data.forEach((item,index)=>{
						if(!(item.fld_action_name=="edit_date")&&!(item.fld_function=="")){
							this.box_res.push(item);
						}
					})
					// this.change_cache_action_data(this.box_res)
				};
				if(res.data.error==-1){
					this.box_data.tips=true;
				   	this.current_state=res.data.message;
				   	window.setTimeout(()=>{
						this.box_data.tips=false
				   	},2000)
				}
			},
			//将选中的数据放在输入框中
			sbmit_data(data){
				//当是新建时把弹框中的数据填进输入框
				if(this.len.length>0){
					this.msg[this.box_index.index1+'-'+this.box_index.box_key]=data;
				}
				//当编辑的时候编辑带弹框的数据
				this.edit_list.some((item)=>{
					if(item==true){
						this.rows[this.box_index.index1][this.box_index.box_key]=data;
					}
				})
				//关闭弹框
				this.close_edit();
			},
			//选择的数据列表，显示在别的组件（选择选中项目然后在别的组件选择项目然后再把数据放到本组件中）
			selecte_btn(data){
				//点击选择物品关闭物品选择框组件（select-service组件）
				// this.box_data.sel_shows=false;
				//把选中的数据赋值给selecte_data
				// console.log(data)
				// console.log(this.rule_data)
				// this.rule_data_p=JSON.parse(this.rule_data);

				this.selecte_data=data;
				// this.rule_data=''
				// this.selecte_data=JSON.stringify(this.selecte_data)
				// this.is_selecte_item=true;
				//显示edit-items组件
				// this.box_data.items=true;
				this.is_components='editItems'
			},
			//权限数组组件输入值
			auth_data(data){
				//当新建的时候编辑带弹框的数据
				if(this.len.length>0){
					this.msg[this.box_index.index1+'-'+this.box_index.box_key]=data;
				};
				//当编辑的时候编辑带弹框的数据
				this.edit_list.some((item)=>{
					if(item==true){
						this.rows[this.box_index.index1][this.box_index.box_key]=data;
					}
				})
				//关闭组件
				this.close_project();
			},
			//关闭编辑物品框（sbmit_data确认执行关闭）
			close_edit(){
				//当选择好选项后让弹框组件关闭
				this.is_components='';
				this.mask=false
				// if(this.box_data.items==true){
				//  	this.box_data.items=false;
				// }
			},
			//关闭选择物品框（给编辑物品组件用）
			close_select(){
				//关闭选择框组件（select-service组件）
				this.is_components='';
				this.mask=false
				// if(this.box_data.sel_shows==true){
				//  	this.box_data.sel_shows=false;
				// }
			},
			//物品选择的弹框
			// sel_goods(data){
			// 	//显示选择物品组件（select-service组件）
			// 	// this.box_data.sel_shows=true;
			// 	// console.log(data)
			// 	// this.rule_data_a=JSON.stringify(data)
			// 	// this.is_components='selectItems'
			// 	// this.head_title='--'+this.$attrs.language_pack[this.language_sel_language].please_select_the_following_items+'--'
			// 	//关闭编辑物品组件
			// 	// this.box_data.items=false;
			// 	// this.is_components=''
			// },
			//管理员密码组件输入值
			pas_confirm(data){
				//当新建的时候编辑带弹框的数据
				if(this.len.length>0){
					this.msg[this.box_index.index1+'-'+this.box_index.box_key]=data;
				};
				//当编辑的时候编辑带弹框的数据
				this.edit_list.some((item)=>{
					if(item==true){
						this.rows[this.box_index.index1][this.box_index.box_key]=data;
					}
				})
			},
			//编辑内容组件输入值
			edit_confirm(data){
				//当新建的时候编辑带弹框的数据
				if(this.len.length>0){
					this.msg[this.box_index.index1+'-'+this.box_index.box_key]=data;
				};
				//当编辑的时候编辑带弹框的数据
				this.edit_list.some((item)=>{
					if(item==true){
						this.rows[this.box_index.index1][this.box_index.box_key]=data;
					}
				})
				//关闭编辑框组件
				this.close_project();
			},
			//时间的选择组件
			time_data(data){
				//当新建的时候编辑带弹框的数据
				if(this.len.length>0){
					this.msg[this.box_index.index1+'-'+this.box_index.box_key]=data;
					if(this.box_index.box_key=='fld_effective_time'){
						this.effective=new Date(this.msg[this.box_index.index1+'-'+this.box_index.box_key]).valueOf();
					}
					if(this.box_index.box_key=='fld_expiration_time'){
						this.expiration=new Date(this.msg[this.box_index.index1+'-'+this.box_index.box_key]).valueOf();
					}
					if(this.box_index.box_key=='fld_end_time'){
						this.expiration=new Date(this.msg[this.box_index.index1+'-'+this.box_index.box_key]).valueOf();
					}
					// console.log(typeof (this.effective),this.expiration)
					if(this.effective!=undefined&&this.expiration!=undefined){
						if(this.expiration<=this.effective){
							this.new_expiration_effective=false;
							//显示提示组件
							this.box_data.tips=true;
							//提示组件中的提示内容
							this.current_state='失效时间不能小于生效时间否则会导致异常';
							//控制显示时间
							setTimeout(()=>{
								this.box_data.tips=false;
							},2000)
						}else{
							this.new_expiration_effective=true;
						}
					}
					
				};
				//当编辑的时候编辑带弹框的数据
				this.edit_list.some((item)=>{
					if(item==true){
						this.rows[this.box_index.index1][this.box_index.box_key]=data;
						//判断失效时间不能小于生效时间
						if(this.box_index.box_key=='fld_effective_time'||this.box_index.box_key=='fld_expiration_time'||this.box_index.box_key=='fld_end_time'){
							this.effective=new Date(this.rows[this.box_index.index1].fld_effective_time).valueOf();
							if(this.rows[this.box_index.index1].fld_expiration_time){
								this.expiration=new Date(this.rows[this.box_index.index1].fld_expiration_time).valueOf();
							}
							if(this.rows[this.box_index.index1].fld_end_time){
								this.expiration=new Date(this.rows[this.box_index.index1].fld_end_time).valueOf();
							}
						}						
						if(this.effective!=undefined&&this.expiration!=undefined){
							// alert(1)
							if(this.expiration<=this.effective){
								this.edit_expiration_effective=false
								//显示提示组件
								this.box_data.tips=true;
								//提示组件中的提示内容
								this.current_state='失效时间不能小于生效时间否则会导致异常';
								//控制显示时间
								setTimeout(()=>{
									this.box_data.tips=false;
								},2000)
							}else{
								// alert(0)
								this.edit_expiration_effective=true
							}	
							// console.log(this.edit_expiration_effective)
						}						
					}
										
						
				})
				
				//关闭时间组件
				this.close_project();
				this.mask=false;
			},
			//危机逃脱邮件列表角色json
			get_role_data(data){
				//当新建的时候编辑带弹框的数据
				if(this.len.length>0){
					this.msg[this.box_index.index1+'-'+this.box_index.box_key]=data;
				};
				//当编辑的时候编辑带弹框的数据
				this.edit_list.some((item)=>{
					if(item==true){
						this.rows[this.box_index.index1][this.box_index.box_key]=data;
					}
				})
				//关闭弹框
				this.close_project();
			},
			//让输入框中的值为弹框中的输入值  活动数据渠道组件（pro组件）
			channel_input_data(data){
				
				//当新建的时候编辑带弹框的数据
				if(this.len.length>0){
					this.msg[this.box_index.index1+'-'+this.box_index.box_key]=data;
				};
				//当编辑的时候编辑带弹框的数据
				this.edit_list.some((item)=>{
					if(item==true){
						this.rows[this.box_index.index1][this.box_index.box_key]=data;
					}
				})
				//关闭弹框
				this.close_project();
			},
			//让输入框中的值为弹框中输入的值  项目工程组件（ppr组件）
			input_data(data,backups){
				// console.log(this.box_index.box_key)
				if(this.box_index.box_key=='fld_language'){
					this.language_params=data
					console.log(this.language_params)
				}
				this.announcement=false;
				//当新建的时候编辑带弹框的数据
				if(this.len.length>0){
					this.msg[this.box_index.index1+'-'+this.box_index.box_key]=data;
					this.msg[this.box_index.index1+'-fld_content_c']=backups;
					
				};
				//当编辑的时候编辑带弹框的数据
				this.edit_list.some((item)=>{
					if(item==true){
						// console.log(this.box_index.index1,this.box_index)
						this.rows[this.box_index.index1][this.box_index.box_key]=data;
						this.rows[this.box_index.index1]['fld_content_c']=backups;
					}
				})
				// this.msg[this.box_index.index1+'-fld_language']=data
				//关闭组件
				this.close_project();
			},
			//关闭弹出框
			close_project(){
				this.is_components=''
				this.mask=false;
				this.announcement=false;
			},
			//查找
			lookup(){
				//当点击查找时因为头部数据存在过滤所有重新拉回数据
				this.fields=this.columns.FIELDS
				//查询接口是否调用
				this.lookup_flag=true;
				//设置序号
				this.child_index = 0;
				//设置页数
				this.page=1;
				//获取选框中的值并赋值请求参数
				let request_parameters={};
				//获取选择的条件
				request_parameters.groupOp=this.project_box;
				// console.log(this.project_box)
				//选泽的是哪一项
				if(request_parameters.groupOp==0){
					request_parameters.groupOp='AND'
				}else if(request_parameters.groupOp==1){
					request_parameters.groupOp='OR'
				}
				//当查询的时候看有多少条数据
				request_parameters.rules=[];
				//遍历有多少组数据
				this.add_num.forEach((item,index)=>{
					//有几条数据就在request_parameters对象中添加几个对象
					request_parameters.rules.push({});
					//遍历头部数据
					for(var i=0;i<this.fields.length;i++){
						//因为有的项目是不能查询的点击查询时会判断哪个字段不能查询此处把不能查询的遍历出去
						if(this.fields[i].Comment==this.project_slected[index]){
							request_parameters.rules[index].field=this.fields[i].Name;
						}
					}
					//遍历当前选择的是那条判断条件
					this.language_query_scope.forEach((item,i)=>{
						if(item==this.type_slected[index]){
							request_parameters.rules[index].op=this.query_code[i]
						}
					})
					request_parameters.rules[index].data=this.condition[index];
					
				})

				if(this.$route.path=='/Sandbox/Launcher/tbl_innotice'||
				this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'||
				this.$route.path=='/Sandbox/Launcher/tbl_notice'||
				this.$route.path=='/Sandbox/Launcher/tbl_gift_content'){
					request_parameters.rules.push({});
					request_parameters.rules[request_parameters.rules.length-1].field='fld_title_id';
					request_parameters.rules[request_parameters.rules.length-1].op='eq';
					let index=JSON.parse(window.sessionStorage.getItem('title_id'));
					request_parameters.rules[request_parameters.rules.length-1].data=index
					// 
					// console.log(index)
					// this.see(index)
				}
				//将对象转换成json数据
				this.Query_project=JSON.stringify(request_parameters);
				//通过父组件执行
				this.$emit('query',this.columns,this.Query_project,this.sort,this.page);
				//让选项数据初始化一条
				this.add_num=[];
				//查询时让弹窗关闭
				this.close_win();
				//返回初始状态
				//查询的添加和移除
				this.condition=[];
				//查询类型选择框
				this.type_slected=[];
				//查询项目选择框
				this.project_slected=[];
				//查询条件
				this.head_data=[];
				this.btn_checkeds=[];
				this.btn_check='';
				this.project_box='';
				//设置查询项目
				this.project_slected.push('');
				//设置查询项目的条件
				this.type_slected.push('');
				//设置输入框中的值
				this.condition.push('');
			},
			//查询重置
			box_reset(){
				// //将输入框数据清空
				this.condition=[];
				// //查询类型选择框
				this.type_slected=[];
				// //查询项目选择框
				this.project_slected=[];
				//项目值
					this.add_num.forEach((item,index)=>{
					// console.log(this.condition[index])
					this.project_slected.push('');
					//类型值
					this.type_slected.push('');
					//输入框值
					this.condition.push('');
					
				})
				this.project_box='';
			},
			//移除查询数据中的某一条
			Query_remove(p){
				//遍历数组中添加的数据有多少移除点击的项
				this.add_num=this.add_num.filter(item=>item!==p)
			},
			//查询多条数据累加选项
			accumulation(){
				//当点击添加的加号时给数组添加不同的项以便给input添加不同的v-model
				//每添加一条数据就像数组push不同的值
				this.search_data+=1;
				this.add_num.push(this.search_data);
				// console.log(this.add_num)
				//每添加一项都会在选择框中添加第一项数据
				//项目值
				this.project_slected.push('');
				//类型值
				this.type_slected.push('');
				//输入框值
				this.condition.push('')
			},
			//关闭查询弹窗
			close_win(){
				this.query_show=false;
				this.mask=false;
				if(!this.lookup_flag){
					this.add_num=[];
				};
				this.search_data=0
				// this.project_box='';
				// //设置查询项目
				// this.project_slected.push('');
				// //设置查询项目的条件
				// this.type_slected.push('');
				// //设置输入框中的值
				// this.condition.push('');			
			},
			//查询
			query(){
				this.bt_revoke();
				this.mask=true;
				//显示查询弹框
				this.query_show=true;
				//查询的添加和移除
				this.condition=[];
				//查询类型选择框
				this.type_slected=[];
				//查询项目选择框
				this.project_slected=[];
				this.head_data=[];
				this.data_show_hide=false;
				//设置查询数据的条数
				this.add_num.push(this.search_data);
				//设置选择条件
				// this.project_box=this.project_condition[0];
				//遍历数据头的数据
				this.fields.forEach((item,index) =>{
					// console.log(item)
					//当点击查询的时候判断需要查寻的条件有哪些
					if(item.Name!="fld_deleted"&&item.Name!=this.response.PRIMARY&&item.Search==1){
						// console.log('======')
						//把需要的条件放在一个数组中
						// this.head_data.push(item.Comment);
						this.head_data.push(item.Comment);
						//在动态的选择框中始终把第一项放在框中
					}				
				})
				this.project_box='';
				//设置查询项目
				this.project_slected.push('');
				//设置查询项目的条件
				this.type_slected.push('');
				//设置输入框中的值
				this.condition.push('');
			},
			//关闭输入框
			close() {
				this.input_page = false;
			},
			//enter事件提交请请求的页数点击底部的第几页出现输入框
			submit_input() {
				// this.bt_revoke();
				//输入框的数据的判断
				//获取动态页数
				let page = this.project_data.page;
				//如果当前的页数不是空 是有效的数字 大于0 小于等于总页数执行
				if (this.project_data.page != '' && !isNaN(this.project_data.page) && Number(this.project_data.page) > 0 && Number(this.project_data.page) <= parseInt(this.project_data.total)) {
					//当数据请求回来再执行下次方法
					if (this.istrue.isnext == true) {
						//获取本页的第一条数据的序号
						this.child_index = this.data_page * (page - 1);
						//当总页数大于当前页数乘每页的条数（说明有当前的页数并且不是最后一页）
						if (this.project_data.records - page * this.data_page >= 0) {
							//本页最后一条数据
							this.child_index_total = this.data_page * page;
						}else{
							//最后一页的数据是16的几倍（总页数是当前页的倍数）
							let positive_integer = window.parseInt(this.project_data.records / this.data_page);
							//最后一页的数据的总条数
							let mantissa = this.project_data.records - positive_integer * this.data_page;
							//本页最后一条数据
							this.child_index_total = (positive_integer) * this.data_page + mantissa;
						};
						//父组件执行接口
						this.$emit('lookup', page,this.sort)
					}
				}else{
					//将页数搜索输入框隐藏
					//将序号默认为0
					this.child_index = 0;
					//将每页的最后一条数据序号设置为第一页的最后一条数据的序号也就是当输入的页数为false时返回第一页的数据
					this.child_index_total = this.data_page;
					//将第一页的第一条数据的序号赋值给第多少条中的data值
					this.child_index_page=1;
					//通过组组件返回第一页数据
					this.$emit('lookup', 1,this.sort)
				}
				//将页数搜索输入框隐藏
				this.input_page = false;
				//将页数赋值为输入的页数
				this.page=page;
				//将第一页的第一条数据的序号赋值给第多少条中的data值
				this.child_index_page=this.data_page*page-this.data_page+1;
				this.local_storage();
				this.deselect();
				this.child_index-=this.num;
				this.child_index_total-=this.num;
				this.increasing-=this.num;
				this.num=0;
			},
			//选择查找的页数当点击时出现输入框输入完成时点enter请求数据当没有点enter而是点击的别的地方不请求数据直接返回之前的状态
			select_input() {
				//显示底部（点击第几页）输入框
				this.input_page = true;
			},
			//删除的确认点击
			async confirm_click() {
				//确认删除标志
				this.confirm_data = true;
				var ids = [];
				//遍历选中的列表
					this.btn_checkeds.forEach((item) => {
						//获取选中的数据的主键并push进数组
						ids.push(this.rows[item][this.response.PRIMARY])
					})
				//将数组的每一项转换成字符串
				var ids_data = ids.join();
				if(this.confirm_data == true){
					var parameter={ids:ids_data,userInfo:this.userInfo};
					var res=await this.async_error(api.delData(this.response,parameter));
					if(!res){
        			  return false
        			};
					var time=new Date().getTime();
					var project={groupOp:'AND'};
					project.rules=[];
					project.rules.push({});
					project.rules[0].field='fld_title_id';
					project.rules[0].op='eq';
					project.rules[0].data=window.sessionStorage.getItem('fld_record_id');
					project=JSON.stringify(project);
					var parameter=this.dynamic_interface_parameters(true,time,this.data_page,this.page,this.response.PRIMARY,this.sort,project);
					this.userInfo=JSON.stringify(this.userInfo);
					parameter.userInfo=this.userInfo;
					if(this.$route.path=='/Sandbox/Launcher/tbl_notice'){
						this.$emit('change_rows',parameter)
					}
					if(this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'){
						this.$emit('change_rows',parameter)
					}
					if(this.$route.path=='/Sandbox/Launcher/tbl_gift_content'){
						this.$emit('change_rows',parameter)
					}
					//删除数据后刷新数据
					if(res.data.error==0){
						this.refresh()
						this.bt_revoke()
					}
					if(res.data.error==-1){
						this.box_data.tips=true;
						this.current_state=res.data.message;
						window.setTimeout(()=>{
							this.box_data.tips=false
						},2000)
					}
				};					
				//关闭弹框
				this.show_hide = false;
			},
			//删除的取消点击
			cancel_click() {
				//确认删除的标志
				this.confirm_data = false;
				//关闭删除弹框
				this.show_hide = false;
				//取消选中项
				this.btn_checkeds=[];
				//取下总选中项
				this.btn_check=false;
				//将选中数据项的样式取消
				this.dynamic={};
			},
			//危机逃脱中的区服选择数据备份
			data_backup(data){
				//当新建的时候编辑带弹框的数据
				if(this.len.length>0){
					this.fields.forEach((item, index) => {
						if(item.Name=='fld_area_j'){
							this.msg[this.box_index.index1+'-'+index]=data;
						}
					})
					
				};
				//当编辑的时候编辑带弹框的数据
				this.edit_list.some((item)=>{
					if(item==true){
						this.fields.forEach((item, index) => {
							if(item.Name=='fld_area_j'){
								this.rows[this.box_index.index1].fld_area_j=data;
							}
						})
					}

				})
				// this.area_backup=data;
				this.area_data=data;
				//关闭编辑框组件
				this.close_project();
			},
			//列表复选框的选中和取消
			tr_list(i){//事件对象 数据项目 数据索引
			var sum=this.btn_checkeds.every((item,index)=>{return item!=i})
				//如果没有选中项
				if(this.btn_checkeds.length==0){
					this.btn_checkeds.push(i);				
				}
				else if(sum){//如果选中项中没有与之相同的值那么加入
					this.btn_checkeds.push(i);
				}
				else{
					this.btn_checkeds=this.btn_checkeds.filter((item,index)=>{//如果选中项中有与之相同的那么移除此项
						return i!=item;
					});
				};
				//如果有选中项
				if(this.btn_checkeds.length>0){
					//总复选框选中
					this.btn_check=true;
					//有选中项的标志
					this.list_some=true;
					//如果有选中项可以点击撤销
					this.revoke = false;
					//如果有选中项不禁用撤销
 					this.btn_revoke = false;
				}else{
					//总复选框不选中
					this.btn_check=false;
					//是否选中的标志
					this.list_some=false;
					//不能点撤销
					this.revoke = true;
					//禁用撤销样式
 					this.btn_revoke = true;
				};
				//如果没有选中项
				if(this.btn_checkeds.length==0){
					this.btn_check=false;
				};
				//点击列表改变背景色
				if(!this.dynamic[i]){
					this.dynamic[i]=i+1;
				}else{
					this.dynamic[i]='';
				}
				// if(this.$route.path=='/Sandbox/Setnotice/tbl_notice'||this.$route.path=='/Sandbox/Setnotice/tbl_horse_lamp'){
				// 	console.log(i)
				// 	this.notice(i)
				// }

				


			},
			//总按钮是否选中
			btn_check_cli() {
				//如果总复选框选中
				if(this.btn_check==true){
					this.list_some=true;//表示列表中有选中项
					//将本页全部选中
					this.rows.forEach((item,i)=>{
						this.btn_checkeds.push(i);
						this.dynamic[i]=i+1;
					})
				}else{
					this.list_some=false;
					this.rows.forEach((item,i)=>{
						this.dynamic[i]='';
						this.btn_checkeds=this.btn_checkeds.filter((item,index)=>{
								return i!=item;
						});
					})		
				}
			},
			//点击动态的数据项后边的三点请求不同的数据
			serch(index_rows,index_fields,key,event) {
				// this.area_data=this.area_backup;
				this.key_s=key;
				this.mask=true;
				this.query_show=false;
				//计算点击元素距离左上边框的距离用来判断时间组件的位置
				this.clientX=event.clientX;
				this.clientY=event.clientY;
				//当访问同一个组件的时候先关闭组件因为数据不同
				//每条数据的索引
				this.box_index.index1=index_rows;
				//数据对象中的索引
				this.box_index.index=index_fields;
				//数据对象中的key
				this.box_index.box_key=key.Name;
				//当是编辑的时候拿出输入框中的值，当是新建的时候拿出新建输入框中的值
				if(this.edit_list.length>0){
					this.language_params=this.rows[index_rows]['fld_language']
					//如果不为空把该值赋值给rule_data
					if(this.rows[index_rows][key.Name]!=undefined){
						
						if(this.rows[index_rows]['fld_content_c']){
							this.rule_data=	this.rows[index_rows]['fld_content_c']
						}else{
							this.rule_data=this.rows[index_rows][key.Name];
						}						
					}else{
						//如果时新建时会新建输入框中的值
						if(this.msg[index_rows+'-fld_content_c']){
							this.rule_data=this.msg[index_rows+'-fld_content_c']
						}else{
							this.rule_data=this.msg[index_rows+'-'+key.Name];
						}
					}
				}else{//如果没有数据则赋值为空
					// this.rule_data=this.msg[this.num-1+'-'+key.Name];
					if(this.msg[this.num-1+'-fld_content_c']){
							this.rule_data=this.msg[this.num-1+'-fld_content_c']
						}else{
							this.rule_data=this.msg[this.num-1+'-'+key.Name];
						}
				};
				//当渲染同一个组件时刷新组件因为组件的数据不同
				for(var i in this.box_data){
					if(this.box_data[i]==true){
						this.box_data[i]=false
					}
				};			
				//判断当点击三个点时是哪个数据头，根据不同的数据头进行不同的接口请求
				let item=this.fields[index_fields];
				this.box_res.forEach((item_in,index)=>{
					if(item_in.fld_action_name==item.Action){						
						//弹框的函数数据
						this.box_fun=JSON.parse(item_in.fld_function)	
					}
				})
				this.ppr_action=item.Action;
				this.ppr_action_param=item.ActionParam;
				switch(item.Action){
					//判断头部三个点字段的值根据值请求不同的接口
					case "IsTest":
						this.is_components='IsTest'
						break;
					case "SelectRegion":
						this.is_components='SelectRegion'
						break;
					case "SelectCountry":
						this.is_components='SelectCountry'
						break;
						
					case "TestEquipment":
						this.is_components='TestEquipment'
						break;
					case "AreaService":
						this.is_components='AreaService'
						break;
					case "AnnouncementType":
						this.is_components='AnnouncementType'
						break;
					case "GameVersion":
						this.is_components='GameVersion'
						break;
					case "selecttion_typevalue":
						this.is_components='choiceApp'
						break;
					case "vChannelsAreas":					
						this.is_components='vChannelsAreas'
						break;
					case "RuleJson":
						this.is_components='ruleJson';
						this.area_service_id=this.rows[index_rows].fld_area;
						break
					case "SystemAnnouncement":
						this.announcement=true;
						break;
					case "LanguageChoice":
							 //action中所有的数据项
						this.is_components='choiceApp'
						break;	
					case "selecttion_appliction":
						this.is_components='choiceApp'
						break;
					case "role_rule_edit":
						// alert("角色 权限数组 直接返回的页面，暂无接口");
						this.is_components='authRoleEdit'
						break;
					case "edit_content":
						// alert("模板参数，直接返回的页面，暂无数据");
						this.is_components='edit'
						break;
					case "edit_password":
						this.is_components='userPas'
						break;
					case "user_role_edit":
						// alert("用户 权限 直接返回的页面 暂无接口");
						this.is_components='jurisdiction'
						break;
					case "selecttion_typeid":
						this.is_components='choiceApp'
						break;
					case "edit_date_time":
						//当点击了时间的三点后先把组件设置为false也就是不显示组件，当同步执行完后再设置为true
						setTimeout(()=>{this.box_data.time=true;},(0))
						break;
					case "SelectMoreClientPacketTank":
						this.is_components='selectDistributionPackage'
						break;
					case "ServerGroupChooseTank":
						this.is_components='selectDistributionPackage'
						break;
					case "ItemArrayEditorTank":
						this.is_components='editItems'
						this.head_title='--'+this.$attrs.language_pack[this.language_sel_language].edit_item+'--';
						this.selecte_data=[];
						break;
					case "SelectClientPacketTank":
						this.is_components='choiceApp'
						break;
					case "SelectGiftPackageTank":
						this.is_components='choiceApp'
						break;
					case "QueryRoleTank":
						this.is_components='selectService'
						this.head_title='--'+this.$attrs.language_pack[this.language_sel_language].select_server_group+'--';
						break;
					case "QueryUserTank":
						this.is_components='selectService'
						this.head_title='--'+this.$attrs.language_pack[this.language_sel_language].select_server_group+'--';
						break;
					case "EditConditionTank":
						this.is_components='mailConditions'
						this.head_title='--'+this.$attrs.language_pack[this.language_sel_language].mail_conditions+'--';
						break;
					case "SelectServerGroupTank":
						this.is_components='choiceApp'
						break;
					case "SelectChargeItemTank":
						this.is_components='choiceApp'
						break;
					case "SelectMailTemplate":
						this.is_components='choiceApp'
						break;
					case "ACTION_COLUMNS_URL":
						this.is_components='choiceApp'
						break;
					case "select_gift_batch_warship":
						this.is_components='choiceApp'
						break;
					case "select_gift_package_warship":
						console.log('没有数据')
						break;
					case "select_package_channel_more":
						console.log('没有数据')
						break;
					case "ItemArrayEditor_warship":
						console.log('没有数据')
						break;
					case "serverChoose_warship":
						//4
						console.log('没有数据')
						break;
					case "packageChoose":
						//2
						console.log('没有数据')
						break;
					case "serverChooseOne_warship":
						console.log('没有数据')
						break;	
				}
			},
			//刷新
			refresh() {
				//正反序标志
				this.sort_flag=true;
				//刷新完成的标志（当刷新接口执行完后在才能在次执行刷新按钮）
				if(this.istrue.isrefresh==true){
					//每页最后一条数据的序号数
					var total=this.child_index_total;
					//当有新建时刷新总页数加上新建的页数
					this.project_data_copy=this.project_data.records+this.num;
					//执行撤销函数（例 当新建没提交刷新时就撤销新建项目 编辑时撤销编辑）
					// this.bt_revoke()
					//触发父组件执行刷新的方法（当点击了新建时刷新时始终是从第一页开始显示）
					if(this.new_data){
						this.child_index=0;
						this.$emit('parent_refresh',this.sort,1);
					}else{
						this.$emit('parent_refresh',this.sort,this.project_data.page);
					}										
					//是否有选中项的标志
					this.list_some =false;
					//取消每条数据的样式
					this.dynamic={};
					//取消总复选框
					this.btn_check = false;
					//取消添加时的累加
					this.increasing=0;
				}				
			},
			//将当前时间转换成零时区时间
			change_time_zone(parameter){
				// console.log(parameter)
				if(parameter==undefined||parameter=='N/A'||parameter==''||parameter==null){
					parameter="1970-01-01 00:00:00";
					return parameter
				}
				function to_2_str(_value) {
			    	if (_value < 10){
						return "0" + _value;
					}   
			    	else{
						return _value;
					}       
				};
				//将时间毫秒数转换成时间对象
				 parameter=parameter.replace(/\-/g,'/')
				var temp=new Date(parameter);
				// console.log(temp)
				//将0时区的信息拼接时间字符串
				 parameter = temp.getUTCFullYear()
			    + "-"
			    + to_2_str(temp.getUTCMonth() + 1)
			    + "-"
			    + to_2_str(temp.getUTCDate())
			    + " "
			    + to_2_str(temp.getUTCHours())
			    + ":"
			    + to_2_str(temp.getUTCMinutes())
			    + ":"
				+ to_2_str(temp.getUTCSeconds());
				return parameter
			},
			//撤销不刷新
			bt_revoke_ref(){
				//新建撤销时返回初始状态
				this.msg_onoff={};
				this.data_show_hide=false
				//正反序标志
				this.sort_flag=true;
				//减去新建时的页数
				this.child_index_total-=this.num;
				//当点击时把新建取消
				this.num = 0;
				//序号的标志点击撤销是序号也跟着减少（每页显示数据*当前页数-每页显示数据）
				this.child_index =this.data_page*this.project_data.page-this.data_page;
				//保存的禁止点击
				this.preservation = true;
				//撤销的禁止点击
				this.revoke = true;
				//编辑的禁止点击
				this.isedit = false;
				//删除的禁止点击
				this.isdel = false;
				//新建的禁止点击
				this.newly_build= false,
				//是否禁用的选项
				this.btn_preservation = true;
				//禁用撤销样式
				this.btn_revoke = true;
				//禁用删除样式
				this.btn_del = false;
				//禁用编辑样式
				this.btn_edit = false;
				//禁用新建样式
				this.btn_build = false;
				this.V_disabled=false;
				//当编辑的时候撤销编辑
				if (this.list_some == true||this.btn_checkeds.length>0) {
					//取消选中项中的值
					if (this.btn_checkeds.length>0) {
						this.btn_checkeds.forEach((item,i)=>{
							//取消选中项
							this.edit_list[item] = false;
						})
						//复选框清空 总复选框为false
						this.btn_checkeds=[];
						this.btn_check = false;
						this.edit_list=[];
					}
					//编辑时候撤销重新刷新数据
					// this.$emit('parent_refresh', this.sort,this.project_data.page);
				};
				// console.log(this.dynamic)
				// var dynamic=Object.keys(this.dynamic);
				// console.log(dynamic)
				// dynamic.forEach((item,index)=>{this.dynamic[index]=item+1})
				// console.log(this.dynamic)
				//是否能执行点击事件或者执行变化事件的标志
				this.tr_flag=true;
				//是否有选中项的标志
				this.list_some =false;
				//取消选中的样式
				this.dynamic={};
				//总复选框取消选中
				this.btn_check = false;
				//将累加清零
				this.increasing=0;
				//输入框中的数据清空
				this.msg = {};
				//动态的内容数组清空
				this.check = {};				
			},
			//撤销刷新
			bt_revoke() {
				//新建撤销时返回初始状态
				this.msg_onoff={};
				this.data_show_hide=false
				//正反序标志
				this.sort_flag=true;
				//减去新建时的页数
				this.child_index_total-=this.num;
				//当点击时把新建取消
				this.num = 0;
				//序号的标志点击撤销是序号也跟着减少（每页显示数据*当前页数-每页显示数据）
				this.child_index =this.data_page*this.project_data.page-this.data_page;
				//保存的禁止点击
				this.preservation = true;
				//撤销的禁止点击
				this.revoke = true;
				//编辑的禁止点击
				this.isedit = false;
				//删除的禁止点击
				this.isdel = false;
				//新建的禁止点击
				this.newly_build= false,
				//是否禁用的选项
				this.btn_preservation = true;
				//禁用撤销样式
				this.btn_revoke = true;
				//禁用删除样式
				this.btn_del = false;
				//禁用编辑样式
				this.btn_edit = false;
				//禁用新建样式
				this.btn_build = false;
				this.V_disabled=false;
				//当编辑的时候撤销编辑
				if (this.list_some == true||this.btn_checkeds.length>0) {
					//取消选中项中的值
					if (this.btn_checkeds.length>0) {
						this.btn_checkeds.forEach((item,i)=>{
							//取消选中项
							this.edit_list[item] = false;
						})
						//复选框清空 总复选框为false
						this.btn_checkeds=[];
						this.btn_check = false;
						this.edit_list=[];
					}
				};
				//是否能执行点击事件或者执行变化事件的标志
				this.tr_flag=true;
				//是否有选中项的标志
				this.list_some =false;
				//取消选中的样式
				this.dynamic={};
				//总复选框取消选中
				this.btn_check = false;
				//将累加清零
				this.increasing=0;
				//输入框中的数据清空
				this.msg = {};
				//动态的内容数组清空
				this.check = {};
				this.refresh();
				this.effective=null;
				this.expiration=null;
				this.new_expiration_effective=true;
				this.edit_expiration_effective=true				
			},
			//当路由是/Sandbox/Setnotice/tbl_notice或者/Sandbox/Setnotice/tbl_horse_lamp时自动查询数据
			auto_query_data(path){
				if(!window.sessionStorage.getItem('project')){
					if(path=='/Sandbox/Launcher/tbl_notice'||
					path=='/Sandbox/Launcher/tbl_horse_lamp'||
					this.$route.path=='/Sandbox/Launcher/tbl_innotice'||
					this.$route.path=='/Sandbox/Launcher/tbl_email'||
					this.$route.path=='/Sandbox/Launcher/tbl_emailSi'||
					this.$route.path=='/Sandbox/Launcher/tbl_gift_content'){
					var time=new Date().getTime();
					// this.rows[index].fld_title.split(',');
					var project={groupOp:'AND'};
					project.rules=[];
					project.rules.push({});
					// console.log(project.rules[index])
					project.rules[0].field='fld_title_id';
					project.rules[0].op='eq';
					project.rules[0].data=window.sessionStorage.getItem('fld_record_id');
					// console.log(window.sessionStorage.getItem('fld_record_id'))
					project=JSON.stringify(project);
					var parameter=this.dynamic_interface_parameters(true,time,this.data_page,this.page,this.response.PRIMARY,this.sort,project);
					this.userInfo=JSON.stringify(this.userInfo);
					parameter.userInfo=this.userInfo;
					if(this.$route.path=='/Sandbox/Launcher/tbl_notice'){
						this.$emit('change_rows',parameter)
					}
					if(this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'){

						this.$emit('change_rows',parameter)
					}
					if(this.$route.path=='/Sandbox/Launcher/tbl_innotice'){

						this.$emit('change_rows',parameter)
					}
					if(this.$route.path=='/Sandbox/Launcher/tbl_email'){

						this.$emit('change_rows',parameter)
					}
					if(this.$route.path=='/Sandbox/Launcher/tbl_emailSi'){

						this.$emit('change_rows',parameter)
					}
					if(this.$route.path=='/Sandbox/Launcher/tbl_gift_content'){
						this.$emit('change_rows',parameter)
					}
				}
				}
				
				
			},
			//新建提交
			async add_submit(num){
				//遍历有多少条数据
				for (var i = num - 1; i >= 0; i--) {
					//请求接口需要的参数
					var parameter = {};
					//遍历每条数据里包含多少项需要提交的数据
					for (var j = 0; j < this.fields.length; j++) {
						if(this.fields[j].Name=='fld_modif_time'||this.fields[j].Name=='fld_create_time'||this.fields[j].Name=='fld_login_time'){
							continue
						}
						//动态的保存参数获取所有的动态参数每有一条数据就会有执行一次每一条的数据就会有多项的动态值
						if(this.fields[j].Name!="fld_deleted"){//判断不需要提交的字段
							//给接口参数赋值this.fields[j].Name!=this.response.PRIMARY||
							parameter[this.fields[j].Name + ''] = this.msg[i + '-' +this.fields[j].Name];
							//如果数据项的类型是复选框
							if(this.fields[j].type=='checkbox'){
								//把复选款的boolean值转换成数字类型
								parameter[this.fields[j].Name + '']=Number(this.check[i+'-'+this.fields[j].Name]);
							};
							//如果项目类型是时间的字段
							if(this.fields[j].FieldType=="datetime"||this.fields[j].FieldType=='timestamp'){
								//获取当前时间的对象
								// var tem;
								if(this.msg[i + '-' + this.fields[j].Name]!='N/A'&&this.msg[i + '-' + this.fields[j].Name]!=''){
									parameter[this.fields[j].Name]=this.msg[i + '-' + this.fields[j].Name]+' '+window.sessionStorage.getItem('time_zone');
								}
								//将当前的时区转换成零时区
								parameter[this.fields[j].Name]=this.change_time_zone(parameter[this.fields[j].Name]);														
							}
							if(this.fields[j].type=='onOff'){
								if(this.msg_onoff[i+'-'+this.fields[j].Name]==undefined||this.msg_onoff[i+'-'+this.fields[j].Name]==null){
									this.msg_onoff[i+'-'+this.fields[j].Name]=0
								}
								parameter[this.fields[j].Name + '']=Number(this.msg_onoff[i+'-'+this.fields[j].Name])
							}
							this.fld_record_id=window.sessionStorage.getItem('fld_record_id');
							if(this.$route.path=='/Sandbox/Launcher/tbl_notice'&&this.fields[j].Name=='fld_title_id'){
								parameter[this.fields[j].Name + '']=this.fld_record_id;
							}
							if(this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'&&this.fields[j].Name=='fld_title_id'){
								parameter[this.fields[j].Name + '']=this.fld_record_id;
							}
							if(this.$route.path=='/Sandbox/Launcher/tbl_innotice'&&this.fields[j].Name=='fld_title_id'){
								parameter[this.fields[j].Name + '']=this.fld_record_id;
							}
							if(this.$route.path=='/Sandbox/Launcher/tbl_email'&&this.fields[j].Name=='fld_title_id'){
								parameter[this.fields[j].Name + '']=this.fld_record_id;
							}
							if(this.$route.path=='/Sandbox/Launcher/tbl_emailSi'&&this.fields[j].Name=='fld_title_id'){
								parameter[this.fields[j].Name + '']=this.fld_record_id;
							}
							if(this.$route.path=='/Sandbox/Launcher/tbl_gift_content'&&this.fields[j].Name=='fld_title_id'){
								parameter[this.fields[j].Name + '']=this.fld_record_id;
							}
						};	
					};
					//定义固定接口参数
					parameter.oper = 'edit';parameter._oper = 'add';parameter.userInfo = this.userInfo;
					//判断失效时间不能小于生效时间
					// if(parameter.fld_effective_time!=null&&parameter.fld_expiration_time!=null){
					// 	let effective=parameter.fld_effective_time.valueOf();
					// 	let expiration=parameter.fld_expiration_time.valueOf();
					// 	if(expiration<=effective){
					// 		//显示提示组件
					// 		this.box_data.tips=true;
					// 		//提示组件中的提示内容
					// 		this.current_state='失效时间不能小于生效时间';
					// 		//控制显示时间
					// 		setTimeout(()=>{
					// 			this.box_data.tips=false;
					// 		},2000)
					// 		//保存的禁止点击
					// 		this.preservation = false;
					// 		//是否保存禁用的样式
					// 		this.btn_preservation = false;
					// 		//撤销的禁止点击
					// 		this.revoke = false;
					// 		//是否撤销禁用的样式
					// 		this.btn_revoke = false;
					// 		return false
					// 		// this.bt_revoke()
					// 	}
					// }
					
					//请求添加接口
					var res=await this.async_error(api.addSubmitData(this.response,parameter));
					if(!res){
        			  return false
        			};
					//点击了新建接口时的标志
					this.new_data=true;
					//新建时项目数据从零开始
					this.child_index=0;
					this.child_index_page=1;
					if(res.data.error==-1){
						//显示提示组件
						this.box_data.tips=true;
						//提示组件中的提示内容
						this.current_state=res.data.message;
						//控制显示时间
						setTimeout(()=>{
							this.box_data.tips=false;
						},2000)
						this.bt_revoke()
					}
					if(i==0){
						this.auto_query_data(this.$route.path)									
						//如果有查询接口请求查询接口(当在查询数据后添加项目后加载全部的数据)
						if(this.isquery==true){
							this.lookup();
						};
						this.bt_revoke()
						this.$emit('parent_data_sort',this.sort,this.sort_name,1);
						this.local_storage();																		
						//提交添加数据后在第一页显示
						this.child_index=0;	
						this.child_index_page=1;
						this.child_index_total=this.data_page
						this.num=0
					}																						
				}
				//累加清零
				this.increasing=0;	
			},
			//编辑提交
			async edit_submit(fields){
				// alert(1)
				// var flag
				this.new_data=false;
				//当点击保存后新建的按钮可以点击
				this.newly_build= false;
				this.btn_build=false;
				//遍历编辑的数据项
				for (let i = 0; i < this.updata_edit.length; i++) {
					var parameter = {};
					//当有复选框的时候把boolean转换成数字类型
					for (let k in this.updata_edit[i]) {
						if(k=='fld_modif_time'||k=='fld_create_time'||k=='fld_login_time'){
							continue
						}
						//如果是复选框转换成数字类型
						if(typeof(this.updata_edit[i][k]) == 'boolean'){
							this.updata_edit[i][k] = Number(this.updata_edit[i][k])
						};	
						// console.log(this.updata_edit[i][k])
						this.fields.forEach((item,index)=>{							
							if(k==item.Name&&item.FieldType=="datetime"||item.FieldType=='timestamp'){
								// var tem;
								// console.log(this.updata_edit[i][k])
								if(this.updata_edit[i][k]==null){
									this.updata_edit[i][k]=''
								}
								if(this.updata_edit[i][k]!='N/A'&&this.updata_edit[i][k]!=''&&this.updata_edit[i][k].indexOf("UTC")!= -1){
									this.updata_edit[i][k]=this.updata_edit[i][k]+' '+window.sessionStorage.getItem('time_zone');
								}
								this.updata_edit[i][k]=this.change_time_zone(this.updata_edit[i][k]);
								// console.log(this.updata_edit[i][k])																		
							}													
						})
						this.fld_record_id=window.sessionStorage.getItem('fld_record_id');
						if(this.$route.path=='/Sandbox/Launcher/tbl_notice'&&k=='fld_title_id'){
							parameter[k]=this.fld_record_id;
						}else if(this.$route.path=='/Sandbox/Launcher/tbl_gift_content'&&k=='fld_title_id'){
							parameter[k]=this.fld_record_id;
						}else if(this.$route.path=='/Sandbox/Launcher/tbl_horse_lamp'&&k=='fld_title_id'){
							parameter[k]=this.fld_record_id;
						}else{
							parameter[k] = this.updata_edit[i][k];	
						}												
					}
					parameter.oper = 'edit';
					parameter._oper = 'edit';
					parameter.userInfo = this.userInfo;
					// //判断失效时间不能小于生效时间
					// if(parameter.fld_effective_time!=null&&parameter.fld_expiration_time!=null){
					// 	// alert(0)
					// 	let effective=parameter.fld_effective_time.valueOf();
					// 	// console.log(effective)
					// 	let expiration=parameter.fld_expiration_time.valueOf();
					// 	if(expiration<=effective){
					// 		//显示提示组件
					// 		this.box_data.tips=true;
					// 		//提示组件中的提示内容
					// 		this.current_state='失效时间不能小于生效时间';
					// 		//控制显示时间
					// 		setTimeout(()=>{
					// 			this.box_data.tips=false;
					// 		},2000)
					// 		//保存的禁止点击
					// 		this.preservation = false;
					// 		//是否保存禁用的样式
					// 		this.btn_preservation = false;
					// 		//撤销的禁止点击
					// 		this.revoke = false;
					// 		//是否撤销禁用的样式
					// 		this.btn_revoke = false;
					// 		this.list_some = true;
					// 		return false
					// 		// this.bt_revoke()
					// 		// this.refresh()
					// 	}
					// }
					// flag=true;
					var res=await this.async_error(api.editSubmitData(this.response,parameter));
					if(!res){
        			  return false
        			};
					this.child_index=this.child_index*this.project_data.page;
					let page=this.project_data.page;
					this.fields=fields;
					//如果返回-1执行提示框
					if(res.data.error==-1){
						this.box_data.tips=true;
						this.current_state=res.data.message;
						setTimeout(()=>{
							this.box_data.tips=false;
						},2000)
						this.bt_revoke()
					}
					if(i+1==this.updata_edit.length){
						this.auto_query_data(this.$route.path)
						//如果调用了查询接口那么添加的时候会自动请求查询接口（所有的数据）
						if(this.Query_project){
							this.bt_revoke()
							this.$emit('parent_data_sort', this.sort,this.sort_name,page);
						}else{
							this.bt_revoke()
							this.$emit('parent_data_sort',  this.sort,this.sort_name,page);
						}		
					}																											
				}
				//把选中项清空
				this.rows.forEach((item, index) => {
					if (this.btn_checkeds.length>0) {
						this.btn_checkeds.forEach((item,i)=>{
							//不渲染编辑列表
							this.edit_list[item] = false;
						})
						//复选框为空
						this.btn_checkeds=[];
						//总复选框为空
						this.btn_check = false
					}
				})
				//修改完成后清空数组项
				this.updata_edit = [];
				this.list_some=false ;
			},
			//提交数据
			submit(fields) {
				// console.log(this.list_some)
				// alert(2)
				this.data_show_hide=false
				//正反序的标志
				this.sort_flag=true;
				//保存的禁止点击
				this.preservation = true;
				//撤销的禁止点击
				this.revoke = true;
				//编辑的禁止点击
				this.isedit = false;
				//删除的禁止点击
				this.isdel = false;
				//是否保存禁用的样式
				this.btn_preservation = true;
				//是否撤销禁用的样式
				this.btn_revoke = true;
				//是否删除禁用的样式
				this.btn_del = false;
				//是否编辑禁用的样式
				this.btn_edit = false;
				// console.log(this.new_expiration_effective)
				//当有新建的时候请求保存的接口
				if (this.num > 0&&this.new_expiration_effective) {
					// alert(0)	
					this.add_submit(this.num)						
				}else if(!this.new_expiration_effective){
					// alert(1)
					// 显示提示组件
					this.box_data.tips=true;
					//提示组件中的提示内容
					this.current_state='失效时间不能小于生效时间';
					//控制显示时间
					setTimeout(()=>{
						this.box_data.tips=false;
					},2000)
					//保存的禁止点击
					this.preservation = false;
					//是否保存禁用的样式
					this.btn_preservation = false;
					//撤销的禁止点击
					this.revoke = false;
					//是否撤销禁用的样式
					this.btn_revoke = false;
					this.list_some = true;
					// this.new_expiration_effective=true;
					return false
				}
				//当有编辑的时候请求保存的接口
				if (this.list_some == true&&this.edit_expiration_effective) {
					this.edit_submit(fields)	
				}else if(!this.edit_expiration_effective){
					// 显示提示组件
					this.box_data.tips=true;
					//提示组件中的提示内容
					this.current_state='失效时间不能小于生效时间';
					//控制显示时间
					setTimeout(()=>{
						this.box_data.tips=false;
					},2000)
					//保存的禁止点击
					this.preservation = false;
					//是否保存禁用的样式
					this.btn_preservation = false;
					//撤销的禁止点击
					this.revoke = false;
					//是否撤销禁用的样式
					this.btn_revoke = false;
					this.list_some = true;
					return false
				}
				//是否能执行点击事件或者执行变化事件的标志
				this.tr_flag=true;
				//是否有选中项的标志
				// this.list_some=false ;													
			},
			//编辑
			updata() {
				this.data_show_hide=false
				this.fields.forEach((ite,index)=>{
					if(ite.Action){
						this.readonly[index]=true;
					}else{
						this.readonly[index]=false;
					}
					this.btn_check_cancel[index]=true;
					this.btn_change();

				})
				//当列表项选中的时候再进行编辑
				if(this.list_some == true){
					//当有编辑项的时候执行是否有弹框的函数如果有就显示弹框按钮
					// this.serch_fn();
					//正反序的标志
					this.sort_flag=false;
					//保存的禁止点击
					this.preservation = false;
					//撤销的禁止点击
					this.revoke = false;
					//编辑的禁止点击
					this.isedit = true;
					//删除的禁止点击
					this.isdel = true;
					//新建的禁止点击
					this.newly_build=true;
					//是否禁用的选项
					this.btn_preservation = false;
					//是否撤销禁用的样式
					this.btn_revoke = false;
					//是否删除禁用的样式
					this.btn_del = true;
					//是否编辑禁用的样式
					this.btn_edit = true;
					//是否新建禁用的样式
					this.btn_build = true;
					//当点击某一条数据时让复选框选中，点击编辑的时候禁止每一项的点击事件
					this.tr_flag=false;
					//当选中其中一项
					//当选中数组中的值大于0时遍历数组
					if (this.btn_checkeds.length>0) {
						this.btn_checkeds.forEach((item,index)=>{
							//当点击编辑时edit_list中的索引数据为true（渲染编辑后输入框的样式）
							this.edit_list[item] = true;
							//把每条数据push进updata_edit数组中(内容数据的副本)
							this.updata_edit.push(this.rows[item]);
							// console.log(this.rows[index])
						})
						
					} else {
						this.isedit = false;
					}
				}else{
					//保存的禁止点击
					this.preservation = true;
					//撤销的禁止点击
					this.revoke = true;
					//编辑的禁止点击
					this.isedit = false;
					//删除的禁止点击
					this.isdel = false;
					//新建的禁止点击
					this.newly_build=false;
					//是否禁用的选项
					this.btn_preservation = true;
					//是否撤销禁用的样式
					this.btn_revoke = true;
					//是否删除禁用的样式
					this.btn_del = false;
					//是否编辑禁用的样式
					this.btn_edit = false;
					//是否新建禁用的样式
					this.btn_build = false;
					//显示提示框
					this.box_data.tips=true;
					this.current_state=this.$attrs.language_pack[this.language_sel_language].please_select_edit_item;
					setTimeout(()=>{
						this.box_data.tips=false;
					},1000)
				}
			},
			//新建
			add() {
				// alert('gggggggg')
				this.area_data=null;
				// this.msg_on_off()
				// console.log(this.fields)
				this.data_show_hide=false
				this.fields.forEach((ite,index)=>{
					if(ite.Action){
						this.readonly[index]=true;
					}else{
						this.readonly[index]=false;
					}
					this.btn_check_cancel[index]=true
					this.btn_change()
				})
				//点击新建后提交新建数据的标志为false（当为true时数据会从第一条开始）
				this.new_data=false;
				//正反序的标志（不能点击排序的正反小三角）
				this.sort_flag=false;
				//总复选框为true
				this.btn_check=true;
				// 复选框为空数组
				this.btn_checkeds=[];
				//取消选中的样式
				// this.dynamic={};
				this.V_disabled=true;
				//点击新建时不能选中复选框
				this.tr_flag=false;
				//点击新建时增加遍历的条数
				this.num += 1;
				//点击新建时序号累加
				this.child_index += 1;
				//当数据项有复选框时新建时不选中
				// this.check.push(false)
				//新建时根据头部类型push不同字段对象判断显示表单字段
				this.len = [];
				//保存的禁止点击
				this.preservation = false;
				//撤销的禁止点击
				this.revoke = false;
				//编辑的禁止点击
				this.isedit = true;
				//删除的禁止点击
				this.isdel = true;
				//是否禁用保存的样式
				this.btn_preservation = false;
				//是否禁用撤销的样式
				this.btn_revoke = false;
				//是否禁用删除的样式
				this.btn_del = true;
				//是否禁用编辑的样式
				this.btn_edit = true;
				//新建时执行函数判断是否显示弹框的标志
				// this.serch_fn();			
				//遍历数据头根据type字段显示不同的表单字段
				this.fields.forEach((item, index) => {
					if (item.type == 'checkbox') {
						var tem = {
							input_show: false,
							check_show: true,
							password_show:false,
							textarea_show:false,
							date_time_show:false,
							on_off_show:false,
						}
					}else if(
							(item.type == 'text'&&item.Readyonly!=true)&&
							(item.type == 'text'&&item.Name!='fld_title_id')&&
							(item.type == 'text'&&item.Name!='fld_record_id')
						){
						// console.log(1)
						var tem = {
							input_show: true,
							check_show: false,
							password_show:false,
							textarea_show:false,
							date_time_show:false,
							on_off_show:false,
						}
					}else if(item.type == 'textarea'){
						var tem = {
							input_show: false,
							check_show: false,
							password_show:false,
							textarea_show:true,
							date_time_show:false,
							on_off_show:false,
						};
					}else if(item.type == 'password'){
						var tem = {
							input_show: false,
							check_show: false,
							password_show:true,
							textarea_show:false,
							date_time_show:false,
							on_off_show:false,
						}
					}else if(item.type == 'date_time'||item.FieldType=='timestamp'){
						var tem = {
							input_show: false,
							check_show: false,
							password_show:false,
							textarea_show:false,
							date_time_show:true,
							on_off_show:false,
						}
					}else if(item.type == 'onOff'){
						var tem = {
							input_show: false,
							check_show: false,
							password_show:false,
							textarea_show:false,
							date_time_show:false,
							on_off_show:true,
						}
					}else if(item.Readyonly==true){
						var tem = {
							input_show: false,
							check_show: false,
							password_show:false,
							textarea_show:false,
							date_time_show:false,
							on_off_show:false,
						}
					}else if(item.Name=='fld_title_id'){
						var tem = {
							input_show: false,
							check_show: false,
							password_show:false,
							textarea_show:false,
							date_time_show:false,
							on_off_show:false,
						}
					}else if(item.Name=='fld_record_id'){
						var tem = {
							input_show: false,
							check_show: false,
							password_show:false,
							textarea_show:false,
							date_time_show:false,
							on_off_show:false,
						}
					}else{
						var tem = {
							input_show: false,
							check_show: false,
							password_show:false,
							textarea_show:false,
							date_time_show:false,
							on_off_show:false,
							title_id:false
						}
					}
					//新建时通过接口参数获取默认值
					if(item.DefaultValue!=undefined){
						if(item.DefaultValue=='0000-00-00 00:00:00'){
							this.msg[this.num-1+'-'+item.Name]='N/A';
						}else{
							this.msg[this.num-1+'-'+item.Name]=item.DefaultValue;	
						}
					};
					//新建时时间字段显示空
					if(item.FieldType=="datetime"||item.FieldType=='timestamp'){
						this.msg[this.num-1+'-'+item.Name]='N/A';
					};
					if (item.Action!=undefined) {//当新建时看看头部数据有没有action字段如果有就显示点击标识
						tem.span_show=true;
					};
					//新建的时候把每条数据的显示标志对象push进数组，然后在模板tr中遍历len数组
					this.len.push(tem);	
					// console.log(this.len)	
				});
				//当点击新建时复选框跟着选中
				for(var i=0;i<this.num;i++){
					this.add_checkeds.push(i);
				};
				//每页最后一条序号数每添加一条就累加1
				this.child_index_total+=1;
				//总页数添加时累加
				this.increasing+=1;
				// this.this.dynamic.forEach((item,index)=>{item=''})
				// for(var i in this.dynamic){
				// 	console.log(this.dynamic[i])
				// 	this.dynamic[i]=''
				// }
				// this.dynamic[this.fld_record_id]='';
				// console.log(this.dynamic)
			},
			//删除数据
			del() {
				this.data_show_hide=false
				//如果总复选框为true
				if (this.btn_check == true) {
					//显示删除弹框
					this.show_hide = true;
				} else {//如果没有选中总复选框则显示提示组件
					this.box_data.tips=true;
					this.current_state=this.$attrs.language_pack[this.language_sel_language].please_select_delete_item;
					setTimeout(()=>{
						this.box_data.tips=false;
					},1000)
				}
			},
			//点击正反小三角切换数据的正序倒序
			data_sort(name) {
				this.sort_name=name;
				//当数据请求完成在执行下次请求
				if (this.istrue.isorder == true) {
					//正序
					if (this.isup == 'itup' && this.isdown == 'itdown') {
						//小三角样式
						this.isup = 'isup';
						this.isdown = 'isdown';
						//正序接口参数
						this.sort='asc';
						//执行父组件函数
						this.$emit('parent_data_sort', this.sort,name,this.project_data.page);
						//每页最后一条序号
						this.child_index_total = this.data_page;
					} else if (this.isup == 'isup' && this.isdown == 'isdown') {//反序
						this.isup = 'itup';
						this.isdown = 'itdown';
						this.sort='desc';
						this.$emit('parent_data_sort',  this.sort,name,this.project_data.page);
						this.child_index_total = this.data_page;
					}
				}
			},
			//首页加载
			home_page() {	
				// this.bt_revoke();
				//当不是第一页的时候	
				if(this.child_index_page!=1){
					//接口加载完在执行下一次请求
					if (this.istrue.isstart == true) {
						
						let page = 1;
						//把复选框的数据清除
						this.btn_check = false;
						this.btn_checkeds.forEach((item, index) => {
							this.btn_checkeds[index] = false
						});
						//项目序号
						this.child_index = 0;
						//每一页的到第多少条数据
						this.child_index_total = this.data_page;
						this.$emit('child_home', page,this.sort);
						//将页数赋值为1
						this.page=page;
						//每一页的第多少条数据
						this.child_index_page=1;
				   	}
				}else{//如果已经是第一页那么显示提示组件
					this.box_data.tips=true;
					this.current_state=this.$attrs.language_pack[this.language_sel_language].first_page;
					setTimeout(()=>{
						this.box_data.tips=false;
					},1000)
				}
				this.local_storage();
				this.deselect();
				// this.child_index-=this.num;
				// this.child_index_total-=this.num;
				this.increasing-=this.num;
				this.num=0;
			},
			//上一页
			previous_page() {
				// this.bt_revoke();
				//执行完成后的标志
				if (this.istrue.isfirst == true) {
					//将复选框的数据清除
					this.btn_check = false;
					this.btn_checkeds.forEach((item, index) => {
						this.btn_checkeds[index] = false
					});
					//当前的页数
					let page = this.project_data.page;
					if (page > 1 && page != undefined && page != null) {
						page--;
						//总条数减去当前的条数如果是最后一页会等于0
						if (parseInt(this.project_data.total)-(page+1) != 0) {
							//根据索引计算序号值开始值（序号等于上一页的序号减去每页的数据条数）
							this.child_index = this.child_index - this.data_page;
							//每一页的到第多少条数据值
							this.child_index_total = this.child_index_total - this.data_page;
							//执行父组件函数
							this.$emit('child',page,this.sort)
						} else {//如果是最后一页的数据
							this.child_index = this.child_index - this.data_page;
							//最后一页的数据是每页条数的几倍
							let positive_integer = window.parseInt(this.project_data.records / this.data_page);
							//检测是不是正整数
							let num=/^[0-9]*[1-9][0-9]*$/.test(this.project_data.records / this.data_page);
							//最后一页的数据的总条数如果是正整数那么mantissa的值就是0所以就是当为0时会直接减去定义好的每页显示的数据
							let mantissa = this.project_data.records - positive_integer * this.data_page;
							if(num==true){//当是正整数的时候会减去每页条数否则永远都会减去0，也就是count值不会变化
								//如果是整数那么大于page
								var num_z=positive_integer-page;
								//是到第几条{{}}中的数据 每页的末尾页数减去每页的页数
								this.child_index_total = this.child_index_total - mantissa-this.data_page*num_z;
							}else{
								//当最后一页添加数据时大于当前页的显示条数时点击前一页要多减去当前页
								//如果不是整数那么不大于page 每页的末尾页数减去最后一页的页数
								this.child_index_total = this.child_index_total - mantissa;
							}
							this.$emit('child_next',this.child_index, page,this.sort);
						};
						//每一页的第多少条数据
						this.child_index_page-=this.data_page
					} else if (page <= 1) {
						this.child_index_page=1;
						this.box_data.tips=true;
						this.current_state=this.$attrs.language_pack[this.language_sel_language].first_page;
						setTimeout(()=>{
							this.box_data.tips=false;
						},1000)
					}
					this.page=page;
					this.local_storage();
					this.deselect();
					this.child_index-=this.num;
					this.child_index_total-=this.num;
					this.increasing-=this.num;
					this.num=0;
				}		
			},
			//下一页
			next_page() {
				// console.log(1)
				// this.bt_revoke();
				//判断当异步函数执行完成在执行同步代码
				if (this.istrue.isnext == true) {
					//如果此时有选中项那么将其清空
					this.btn_check = false;
					this.btn_checkeds.forEach((item, index) => {
						this.btn_checkeds[index] = false
					});
					//当前的页数
					let page = this.project_data.page;
					// console.log(page)
					//表的总页数
					let positive_integer = window.parseInt(this.project_data.total);
					//当小于总页数的时候执行下一页的按钮
					if (page < positive_integer && page != undefined && page != null) {
						//页数累加
						page++;
						//当总页数减去上一页的最后一条数据页数大于每页的页数时说明不是最后一页
						if (this.project_data.records - this.child_index_total > this.data_page) {
							//当点击下一页后序号加上每页的总页数
							this.child_index = this.child_index + this.data_page;
							//每页的最后一条数据页数也加上每页的总页数
							this.child_index_total = this.child_index_total + this.data_page;
							//执行父组件函数
							this.$emit('child_next',this.child_index, page,this.sort)
						} else {//如果总页数减去上一页的最后一条数据页数小于或者等于每页的页数说明是最后一页
							//当点击下一页后序号加上每页的总页数
							this.child_index = this.child_index + this.data_page;
							//最后一页的数据数
							this.child_index_total=this.project_data.records;
							this.$emit('child_next',this.child_index, page,this.sort);
						};												
						//每一页的第多少条数据
						this.child_index_page+=this.data_page
					} else if (page >= positive_integer) {
						this.box_data.tips=true;
						this.current_state=this.$attrs.language_pack[this.language_sel_language].last_page;
						setTimeout(()=>{
							this.box_data.tips=false;
						},1000)
					}
					this.page=page;
					this.local_storage();
					this.deselect();
					//当点击新建后点下一页后取消新建
					this.child_index-=this.num;
					this.child_index_total-=this.num;
					this.increasing-=this.num;
					this.num=0;
				} 
			},
			//尾页
			last_page() {
				// this.bt_revoke();
				//当返回数据时在请求
				if (this.istrue.isend == true) {
					//把按钮选中的时候取消
					this.btn_check = false;
					this.btn_checkeds.forEach((item, index) => {
						this.btn_checkeds[index] = false
					});
					//最后一页的数据是16的几倍
					let positive_integer = window.parseInt(this.project_data.records / this.data_page);
					//检测是不是正整数
					let num=/^[0-9]*[1-9][0-9]*$/.test(this.project_data.records / this.data_page)
					//最后一页的数据的总条数
					let mantissa = this.project_data.records - positive_integer * this.data_page;
					//总页数
					var pasin = window.parseInt(this.project_data.total);
					//判断是否是最后一页
					if(this.page!=pasin){
						this.page=pasin;
						//如果是正整数说明最后一页是每页条数的整数倍
						if(num==false){//当总数据数除以总页数不是整数时则序号数为总页数的前一页乘以每页显示的数
							this.child_index = (positive_integer) * this.data_page;//最后一页第一条数据的序号
							this.child_index_page=this.project_data.records-mantissa+1;//最后一页的第{{}}中的数据为总数据数减去最后一页的数加上1
						}else{
							this.child_index = (positive_integer) * this.data_page-this.data_page;//如果是整数那么最后一页的数据的序号总页数乘以每页的页数减去一页的页数
							this.child_index_page=this.project_data.records-this.data_page+1;//最后一页的第{{}}中的数据为总数据页数减去最后一页页数加上1
						};
						this.child_index_total = (positive_integer) * this.data_page + mantissa; //是到第几条{{}}中的数据
						this.$emit('child_end',this.child_index, pasin,this.sort)
					}else{
						this.box_data.tips=true;
						this.current_state=this.$attrs.language_pack[this.language_sel_language].last_page;
						setTimeout(()=>{
							this.box_data.tips=false;
						},1000)
					}
						this.local_storage();
						this.deselect();
						// this.child_index-=this.num;
						// this.child_index_total-=this.num;
						this.increasing-=this.num;
						this.num=0;
				}

			},
		},
		//移动弹框
		directives: {
            drag: {
				inserted(el) {
                let drag_Box = el; //获取当前元素
                let dragBox = document.getElementsByClassName('modal-header')[0];
                	dragBox.onmousedown = e => {
                	    //算出鼠标相对元素的位置
                	    let disX = e.clientX - drag_Box.offsetLeft;
                	    let disY = e.clientY - drag_Box.offsetTop;
                	    document.onmousemove = e => {
                	        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                	        let left = e.clientX - disX;
                	        let top = e.clientY - disY;
                	        //移动当前元素
                	        drag_Box.style.left = left + "px";
                	        drag_Box.style.top = top + "px";
                	    };
                	    document.onmouseup = e => {
                	          //鼠标弹起来的时候不再移动
                	          document.onmousemove = null;
                	         //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
                	        document.onmouseup = null;
                	    };
                	};
            	}
        	}
    	}
	}
</script>
<style scoped>
.active{
    background: #c1bebe;
    cursor: no-drop;
}
.increase{
	vertical-align: top;
}
.input-content{
	max-height: 400px;
    overflow: auto;
}
.iconfont{
	font-size: 12px;
}
.hello{
	margin-top: -2px;
}
.thb{
	color:#095ee8
}
#tbody input{
    border: none;
    height: 25px;
}
.table tr th{
	background-color: #ebecf0;
	    transform: translateY(0px);
		text-align: center;
}
.table tr td,th{
	padding-left: 10px!important;
	padding-right: 10px!important;
	vertical-align:middle;
	box-shadow: inset 1px 0 0 0 #dee2e6;
	background-color: #ebecf0;	
}
td{
	padding: 0;
}
.table td{
	padding: 0;
}
.list_color{
	background:#e4fdda!important;
}
.fa-ellipsis-h{
	color: #fff;
}
button, input{
	outline: none;
	/* padding: 0 10px; */
	/* width: 175px; */
}
.number{
	width: 45px;
}
    .row-a{
		margin-top: 20px;
	}
    .modal-header{
		cursor: move;
	}
	.modal{
		width: 500px;
	}
	.serch_box{
		padding: 4px 3px;
		background-color: #AAB2BD;
		cursor: pointer;
	    margin-left: -15px;
		position: relative;
	}
	tbody tr:hover{
		/* background-color: #f9f9cc; */
		background-color: #e8efe5;
	} 
	thead td{
		color: #007bff;
		font-weight: 700;
		z-index: 1;
	}
	thead td:hover{
		background: #e4fdda;
	}
	.footer-query{
		color:#007bff;
		font-size:12px;
		border: 1px solid rgb(128, 128, 128);
		padding: 4px;
	}
	.footer-query i{
		transform:rotate(90deg); 
		/* margin-left:4px */
	}
	.footer-reset{
		color:#007bff;
		font-size:12px;
		border:1px solid #808080;
		padding:4px;
		/* margin-right: 362px; */
	}
	/* .footer-reset i{
		margin-right: 5px;
	} */
	.body-i{
		font-size:18px;
		vertical-align:top;
		color: #808080;
		cursor: pointer;
		border:1px solid  #808080;
		border-left:none;
		padding:0px 2px 0px 2px;
		color:#007bff
	}
	.body-input{
		vertical-align:top;
		height: 26px;
		margin-left: 1px;
		outline: none;
		font-size: 14px;
	}
	.body-sle-one{
		font-size: 12px; 
		height: 26px;
		line-height: 27px;
		outline: none;
		margin-left: 1px;
	}
	.body-sle{
		font-size: 12px; 
		height: 26px;
		line-height: 27px;
		outline: none;
	}
	.body-sty{
		font-size: 12px; 
		height: 26px;
		line-height: 27px;
		outline: none;
		border-radius: 0;
	}
	.body-sty option{
		font-size:12px
	}
	.modal-body{
		padding:6px;
	}
	.modal-body i{
		font-size:18px;
		cursor: pointer;
		border: 1px solid #808080;
		border-left:none;
		color:#007bff;
		padding-left: 5px;
    	padding-right: 5px;
	}
	.modal-span{
		font-size:20px;
		margin-top:-14px;
		cursor:pointer
	}
	.modal-title{
		line-height:1px
	}
	.modal-header{
		background:#ebecf0;
		height:40px
	}
	.query{
        display: block; 
		position: fixed;
		top:30%;
		left: 20%;
	}
	tr {
		height: 42px;
	}

	.popup {
		z-index: 10;
		background-color: #5f5f5f;
		/* max-width: 200px; */
		color: #fff;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.show_heid{
		z-index: 10;
		background-color: #dcdcdc;
		/* max-width: 200px; */
		color: #000;
		position: fixed;
		top: 80%;
		left: 22%;
		transform: translate(-50%, -50%);
		padding: 10px;
	}
	.show_heid_btn{
		padding: 10px;
	}
	.show_heid_btn:hover{
		color: darkseagreen;
	}
	.content {
		margin: 10px 10px 10px 10px;
	}

	.confirm {
		margin-left: 10px;
		margin-bottom: 10px;
	}

	.cancel {
		/* margin-left: 49%; */
		margin-right: 10px;
    	float: right;
		margin-bottom: 10px;
	}

	.color {
		opacity: .5;
		cursor: no-drop;
	}

	.fa-up {
		margin-bottom: 2px;
		width: 0;
		display: block;
		height: 0;
		overflow: hidden;
		font-size: 0;
		line-height: 0;
		border-width: 3px;
		border-style: dashed dashed solid dashed;
		border-color: transparent transparent #696969 transparent;
		cursor: pointer;
	}

	.fa-down {
		display: block;
		width: 0;
		height: 0;
		overflow: hidden;
		font-size: 0;
		line-height: 0;
		border-width: 3px;
		border-style: solid dashed dashed dashed;
		border-color: #000000 transparent transparent transparent;
		cursor: pointer;
	}

	.isup {
		border-color: transparent transparent #000000 transparent;
	}

	.isdown {

		border-color: #696969 transparent transparent transparent;
	}

	.itup {
		border-color: transparent transparent #696969 transparent;
	}

	.itdown {

		border-color: #000000 transparent transparent transparent;
	}

	td {
		overflow: hidden;
		text-overflow: ellipsis;
	    /* padding: 0.75rem 0.9rem; */
		box-shadow: inset 1px 0 0 0 #dee2e6;
    	border-bottom: 1px solid #dee2e6;
		padding-left: 10px!important;
    	padding-right: 10px!important;
	}

	button {
		border-radius: 5px;
		font-size: 12px;
		margin-left: 10px;
		outline: none;
		border: none;
		/* width: 40px; */
		height: 25px;
		background: #095ee8;
		color: #ffffff;
	}

	.fixed {
		width: 40px;
		text-align: center;
		color: #007bff;
	}

	.t-table {
		font-size: 12px;
		border: 1px solid #dee2e6
		/* float: right; */
		/* overflow: auto; */
		/* max-height: 753px; */
	}

	.pagination a {
		color: #095ee8;
	}

	.page {
		margin: 0 10px;
		text-decoration: none;
	}

	.page-num {
		margin-right: 15px;
	}

	.total {
		color: #095ee8;
		font-size: 13px;
		/* padding-left: 300px; */
		text-align: right;
		margin-left: -20px;
	}
	.total-page{
		text-align: center;
	}
	.thead {
		background-color: #ebecf0;
	    transform: translateY(0px);
		/* text-align: center; */
		/* z-index: 1; */
	}

	.list {
		padding-top: 10px;
		padding-right: 20px;
	}

	.shop {
		padding: 0;
		margin: 0;
		margin-top: 53px;
	}

	/* .Page{
		 text-align: center;
		margin: 0 auto;
	} */
	.fa-backward {
		margin-left: 10px;
	}

	.fa-forward {
		margin-right: 10px;
	}

	.fun {
		/* margin-left: 100px; */
		text-align: center;
	}

	h3 {
		margin: 40px 0 0;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	.footer {
		font-size: 13px;
		
		/* position: fixed; */
		/* bottom: 10px; */
	}
	.footer-1{
		margin-left: 15px;
	}
	.input-width{
		width: 100%;
	}
	.modal-footer{
		justify-content: space-between;
	}




	.onoffswitch {
        position: relative; 
        width: 50px;
		margin: 0 auto;
    	top: 5px;
        /* -webkit-user-select:none; */
        /* -moz-user-select:none;  */
        /* -ms-user-select: none; */
    }
    .onoffswitch-checkbox {
        display: none;
    }
    .onoffswitch-label {
        display: block; 
        overflow: hidden; 
        cursor: pointer;
        /* border: 2px solid #E3E3E3;  */
        border-radius: 36px;
    }
    .onoffswitch-inner {
        display: block; 
        width: 200%; 
        margin-left: -100%;
        /* transition: margin 0.3s ease-in 0s; */
    }
    .onoffswitch-inner:before, .onoffswitch-inner:after {
        display: block; 
        float: left; 
        width: 50%; 
        height: 18px; 
        padding: 0; 
        line-height: 18px;
        font-size: 12px; 
        color: white; 
        /* font-family: Trebuchet, Arial, sans-serif;  */
        /* font-weight: bold; */
        box-sizing: border-box;
    }
    .onoffswitch-inner:before {
            content: "ON";
            padding-left: 8px;
            background-color: #38d0e8;
            color: #fff;
            text-align: left;
    }
    .onoffswitch-inner:after {
        content: "OFF";
        padding-right: 8px;
        background-color: #cdc9c9; 
        color: #fff;
        text-align: right;
		padding-left: 22px;
    }
    .onoffswitch-switch {
        display: block; 
        width: 20px; 
        margin: 0px;
        background: #e5e0e0;
        position: absolute; 
        top: 0; bottom: 0;
        right: 30px;
        /* border: 2px solid #E3E3E3;  */
        border-radius: 36px;
        /* transition: all 0.3s ease-in 0s;  */
    }
    .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
        margin-left: 0;
    }
    .onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
        right: 0px; 
        background-color: #e5e0e0; 
    }
</style>
